// This file is auto-generated by scripts/generate-svgicon-index.mjs.
// Do not edit manually.

export const SVG_ICON_CATALOG: Readonly<Record<string, string>> = {
  "1001tracklists": "1001Tracklists",
  "1and1": "1&1",
  "1dot1dot1dot1": "1.1.1.1",
  "1panel": "1Panel",
  "1password": "1Password",
  "2fas": "2FAS",
  "2k": "2K",
  "30secondsofcode": "30 seconds of code",
  "365datascience": "365 Data Science",
  "3m": "3M",
  "42": "42",
  "4chan": "4chan",
  "4d": "4D",
  "500px": "500px",
  "7zip": "7Zip",
  "99designs": "99designs",
  "9gag": "9GAG",
  "abb": "ABB",
  "abbott": "Abbott",
  "abbvie": "Abbvie",
  "abdownloadmanager": "AB Download Manager",
  "aboutdotme": "about.me",
  "abstract": "Abstract",
  "abusedotch": "abuse.ch",
  "academia": "Academia",
  "accenture": "Accenture",
  "accusoft": "Accusoft",
  "accuweather": "AccuWeather",
  "acer": "Acer",
  "acm": "ACM",
  "acode": "Acode",
  "actigraph": "ActiGraph",
  "activeloop": "Activeloop",
  "activision": "Activision",
  "activitypub": "ActivityPub",
  "actix": "Actix",
  "actualbudget": "Actual Budget",
  "acura": "Acura",
  "ada": "Ada",
  "adafruit": "Adafruit",
  "adaway": "AdAway",
  "adblock": "AdBlock",
  "adblockplus": "Adblock Plus",
  "addydotio": "addy.io",
  "adguard": "AdGuard",
  "adidas": "Adidas",
  "adminer": "Adminer",
  "adonisjs": "AdonisJS",
  "adp": "ADP",
  "adroll": "Adroll",
  "adventofcode": "Advent Of Code",
  "adyen": "Adyen",
  "aegisauthenticator": "Aegis Authenticator",
  "aeroflot": "Aeroflot",
  "aeromexico": "Aerom&#233;xico",
  "afdian": "AFDIAN",
  "affine": "AFFiNE",
  "aframe": "A-Frame",
  "afterpay": "Afterpay",
  "aftership": "AfterShip",
  "agentskills": "Agent Skills",
  "agora": "Agora",
  "aib": "AIB",
  "aidungeon": "AI Dungeon",
  "aiohttp": "AIOHTTP",
  "aiqfome": "Aiqfome",
  "airasia": "AirAsia",
  "airbnb": "Airbnb",
  "airbrake": "Airbrake",
  "airbus": "Airbus",
  "airbyte": "Airbyte",
  "aircall": "Aircall",
  "aircanada": "Air Canada",
  "airchina": "Air China",
  "airfrance": "Air France",
  "airindia": "Air India",
  "airplayaudio": "AirPlay Audio",
  "airplayvideo": "AirPlay Video",
  "airserbia": "Air Serbia",
  "airtable": "Airtable",
  "airtel": "Airtel",
  "airtransat": "Air Transat",
  "ajv": "Ajv",
  "akamai": "Akamai",
  "akasaair": "Akasa Air",
  "akaunting": "Akaunting",
  "akiflow": "Akiflow",
  "alacritty": "Alacritty",
  "alamy": "Alamy",
  "albertheijn": "Albert Heijn",
  "alby": "Alby",
  "alchemy": "Alchemy",
  "aldinord": "Aldi Nord",
  "aldisud": "Aldi S&#252;d",
  "alfred": "Alfred",
  "algolia": "Algolia",
  "algorand": "Algorand",
  "alibabacloud": "Alibaba Cloud",
  "alibabadotcom": "Alibaba.com",
  "alienware": "Alienware",
  "aliexpress": "AliExpress",
  "alipay": "Alipay",
  "alist": "AList",
  "allegro": "Allegro",
  "alliedmodders": "AlliedModders",
  "alltrails": "AllTrails",
  "almalinux": "AlmaLinux",
  "alpinedotjs": "Alpine.js",
  "alpinelinux": "Alpine Linux",
  "alternativeto": "AlternativeTo",
  "alwaysdata": "Alwaysdata",
  "amd": "AMD",
  "ameba": "Ameba",
  "americanairlines": "American Airlines",
  "americanexpress": "American Express",
  "amg": "AMG",
  "amp": "AMP",
  "amul": "Amul",
  "ana": "ANA",
  "anaconda": "Anaconda",
  "analogue": "Analogue",
  "andela": "Andela",
  "android": "Android",
  "androidauto": "Android Auto",
  "androidstudio": "Android Studio",
  "angular": "Angular",
  "anichart": "AniChart",
  "anilist": "AniList",
  "animalplanet": "Animal Planet",
  "animedotjs": "Anime.js",
  "ankermake": "AnkerMake",
  "anki": "Anki",
  "ansible": "Ansible",
  "answer": "Answer",
  "ansys": "Ansys",
  "anta": "Anta",
  "antdesign": "Ant Design",
  "antena3": "Antena 3",
  "antennapod": "AntennaPod",
  "anthropic": "Anthropic",
  "antv": "AntV",
  "anycubic": "Anycubic",
  "anydesk": "AnyDesk",
  "anytype": "Anytype",
  "apache": "Apache",
  "apacheairflow": "Apache Airflow",
  "apacheant": "Apache Ant",
  "apachearrow": "Apache Arrow",
  "apacheavro": "Apache Avro",
  "apachecassandra": "Apache Cassandra",
  "apachecloudstack": "Apache CloudStack",
  "apachecordova": "Apache Cordova",
  "apachecouchdb": "Apache CouchDB",
  "apachedolphinscheduler": "Apache DolphinScheduler",
  "apachedoris": "Apache Doris",
  "apachedruid": "Apache Druid",
  "apacheecharts": "Apache ECharts",
  "apacheflink": "Apache Flink",
  "apachefreemarker": "Apache FreeMarker",
  "apachegroovy": "Apache Groovy",
  "apacheguacamole": "Apache Guacamole",
  "apachehadoop": "Apache Hadoop",
  "apachehbase": "Apache HBase",
  "apachehive": "Apache Hive",
  "apachejmeter": "Apache JMeter",
  "apachekafka": "Apache Kafka",
  "apachekylin": "Apache Kylin",
  "apachelucene": "Apache Lucene",
  "apachemaven": "Apache Maven",
  "apachenetbeanside": "Apache NetBeans IDE",
  "apachenifi": "Apache NiFi",
  "apacheopenoffice": "Apache OpenOffice",
  "apacheparquet": "Apache Parquet",
  "apachepdfbox": "Apache PDFBox",
  "apachepulsar": "Apache Pulsar",
  "apacherocketmq": "Apache RocketMQ",
  "apachesolr": "Apache Solr",
  "apachespark": "Apache Spark",
  "apachestorm": "Apache Storm",
  "apachesuperset": "Apache Superset",
  "apachetomcat": "Apache Tomcat",
  "aparat": "Aparat",
  "apifox": "Apifox",
  "apmterminals": "APM Terminals",
  "apollographql": "Apollo GraphQL",
  "apostrophe": "Apostrophe",
  "appgallery": "AppGallery",
  "appian": "Appian",
  "appimage": "AppImage",
  "appium": "Appium",
  "apple": "Apple",
  "applearcade": "Apple Arcade",
  "applemail": "Mail",
  "applemusic": "Apple Music",
  "applenews": "Apple News",
  "applepay": "Apple Pay",
  "applepodcasts": "Apple Podcasts",
  "appletv": "Apple TV",
  "appmanager": "AppManager",
  "appsignal": "AppSignal",
  "appsmith": "Appsmith",
  "appstore": "App Store",
  "appveyor": "AppVeyor",
  "appwrite": "Appwrite",
  "aqua": "Aqua",
  "aral": "ARAL",
  "arangodb": "ArangoDB",
  "arc": "Arc",
  "arcgis": "ArcGIS",
  "archicad": "Archicad",
  "archiveofourown": "Archive of Our Own",
  "archlinux": "Arch Linux",
  "ardour": "Ardour",
  "arduino": "Arduino",
  "argo": "Argo",
  "argos": "Argos",
  "ariakit": "Ariakit",
  "arkecosystem": "ARK Ecosystem",
  "arlo": "Arlo",
  "arm": "Arm",
  "armkeil": "Arm Keil",
  "arstechnica": "Ars Technica",
  "artifacthub": "Artifact Hub",
  "artixlinux": "Artix Linux",
  "artstation": "ArtStation",
  "arxiv": "arXiv",
  "asahilinux": "Asahi Linux",
  "asana": "Asana",
  "asciidoctor": "Asciidoctor",
  "asciinema": "asciinema",
  "asda": "ASDA",
  "aseprite": "Aseprite",
  "assemblyscript": "AssemblyScript",
  "asterisk": "Asterisk",
  "astonmartin": "Aston Martin",
  "astra": "Astra",
  "astral": "Astral",
  "astro": "Astro",
  "asus": "ASUS",
  "atandt": "AT&T",
  "atari": "Atari",
  "atlasos": "AtlasOS",
  "atlassian": "Atlassian",
  "auchan": "Auchan",
  "audacity": "Audacity",
  "audi": "Audi",
  "audible": "Audible",
  "audiobookshelf": "Audiobookshelf",
  "audioboom": "Audioboom",
  "audiomack": "Audiomack",
  "audiotechnica": "Audio-Technica",
  "aurelia": "Aurelia",
  "autentique": "Autentique",
  "auth0": "Auth0",
  "authelia": "Authelia",
  "authentik": "Authentik",
  "autocad": "AutoCAD",
  "autocannon": "AutoCannon",
  "autodesk": "Autodesk",
  "autodeskmaya": "Autodesk Maya",
  "autodeskrevit": "Autodesk Revit",
  "autohotkey": "AutoHotkey",
  "autoit": "AutoIt",
  "automattic": "Automattic",
  "autoprefixer": "Autoprefixer",
  "autozone": "AutoZone",
  "avajs": "avajs",
  "avaloniaui": "AvaloniaUI",
  "avast": "Avast",
  "avianca": "avianca",
  "avira": "Avira",
  "avm": "AVM",
  "await": "Await",
  "awesomelists": "Awesome Lists",
  "awesomewm": "awesomeWM",
  "awwwards": "Awwwards",
  "axios": "Axios",
  "axisbank": "Axis Bank",
  "b4x": "B4X",
  "babel": "Babel",
  "babelio": "Babelio",
  "babylondotjs": "Babylon.js",
  "backblaze": "Backblaze",
  "backbone": "Backbone",
  "backbonedotjs": "Backbone.js",
  "backendless": "Backendless",
  "backstage_casting": "Backstage",
  "backstage": "Backstage",
  "badoo": "Badoo",
  "baidu": "Baidu",
  "bakalari": "Bakal&#225;&#345;i",
  "bamboo": "Bamboo",
  "bambulab": "Bambu Lab",
  "bandcamp": "Bandcamp",
  "bandlab": "BandLab",
  "bandrautomation": "B&R Automation",
  "bandsintown": "Bandsintown",
  "bankofamerica": "Bank of America",
  "barclays": "Barclays",
  "baremetrics": "Baremetrics",
  "barmenia": "Barmenia",
  "basecamp": "Basecamp",
  "baserow": "Baserow",
  "baseui": "Base UI",
  "basicattentiontoken": "Basic Attention Token",
  "bastyon": "Bastyon",
  "bat": "bat",
  "bata": "Bata",
  "battledotnet": "Battle.net",
  "bazel": "Bazel",
  "beatport": "Beatport",
  "beats": "Beats",
  "beatsbydre": "Beats by Dre",
  "beatstars": "BeatStars",
  "beekeeperstudio": "Beekeeper Studio",
  "behance": "Behance",
  "beijingsubway": "Beijing Subway",
  "bem": "BEM",
  "bentley": "Bentley",
  "bento": "Bento",
  "bentobox": "BentoBox",
  "bentoml": "BentoML",
  "bereal": "BeReal",
  "betfair": "Betfair",
  "betterauth": "Better Auth",
  "betterdiscord": "BetterDiscord",
  "betterstack": "Better Stack",
  "bevy": "Bevy",
  "bigbasket": "bigbasket",
  "bigbluebutton": "BigBlueButton",
  "bigcartel": "Big Cartel",
  "bigcommerce": "BigCommerce",
  "bilibili": "Bilibili",
  "billboard": "Billboard",
  "bim": "BIM",
  "binance": "Binance",
  "bioconductor": "Bioconductor",
  "biolink": "Bio Link",
  "biome": "Biome",
  "bisecthosting": "BisectHosting",
  "bit": "Bit",
  "bitbucket": "Bitbucket",
  "bitcoin": "Bitcoin",
  "bitcoincash": "Bitcoin Cash",
  "bitcoinsv": "Bitcoin SV",
  "bitcomet": "BitComet",
  "bitdefender": "Bitdefender",
  "bitly": "Bitly",
  "bitrise": "Bitrise",
  "bitsy": "Bitsy",
  "bittorrent": "BitTorrent",
  "bitwarden": "Bitwarden",
  "bitwig": "Bitwig",
  "black": "Black",
  "blackberry": "Blackberry",
  "blackmagicdesign": "Blackmagic Design",
  "blazemeter": "Blazemeter",
  "blazor": "Blazor",
  "blender": "Blender",
  "blibli": "Blibli",
  "blockbench": "Blockbench",
  "blockchaindotcom": "Blockchain.com",
  "blogger": "Blogger",
  "bloglovin": "Bloglovin",
  "blueprint": "Blueprint",
  "bluesky": "Bluesky",
  "bluesound": "Bluesound",
  "bluetooth": "Bluetooth",
  "bmcsoftware": "BMC Software",
  "bmw": "BMW",
  "bnbchain": "BNB Chain",
  "boardgamegeek": "BoardGameGeek",
  "boat": "boAt",
  "boehringeringelheim": "Boehringer Ingelheim",
  "boeing": "Boeing",
  "bohemiainteractive": "Bohemia Interactive",
  "bombardier": "Bombardier",
  "bookalope": "Bookalope",
  "bookbub": "BookBub",
  "bookingdotcom": "Booking.com",
  "bookmeter": "Bookmeter",
  "bookmyshow": "BookMyShow",
  "bookstack": "BookStack",
  "boost": "Boost",
  "boosty": "Boosty",
  "boots": "Boots",
  "bootstrap": "Bootstrap",
  "borgbackup": "BorgBackup",
  "bosch": "Bosch",
  "bose": "Bose",
  "botblecms": "Botble CMS",
  "boulanger": "boulanger",
  "bower": "Bower",
  "box": "Box",
  "boxysvg": "Boxy SVG",
  "braintree": "Braintree",
  "braintrust": "Braintrust",
  "brandfetch": "Brandfetch",
  "brandfolder": "Brandfolder",
  "brave": "Brave",
  "breaker": "Breaker",
  "brenntag": "Brenntag",
  "brevo": "Brevo",
  "brex": "Brex",
  "bricks": "Bricks",
  "britishairways": "British Airways",
  "broadcom": "Broadcom",
  "bruno": "Bruno",
  "bsd": "BSD",
  "bspwm": "bspwm",
  "bt": "BT",
  "buddy": "Buddy",
  "budibase": "Budibase",
  "buefy": "Buefy",
  "buffer": "Buffer",
  "bugatti": "Bugatti",
  "bugcrowd": "Bugcrowd",
  "buhl": "Buhl",
  "buildkite": "Buildkite",
  "builtbybit": "BuiltByBit",
  "bukalapak": "Bukalapak",
  "bulma": "Bulma",
  "bun": "Bun",
  "bungie": "Bungie",
  "bunnydotnet": "bunny.net",
  "bunq": "bunq",
  "burgerking": "Burger King",
  "burpsuite": "Burp Suite",
  "burton": "Burton",
  "buymeacoffee": "Buy Me A Coffee",
  "buysellads": "BuySellAds",
  "buzzfeed": "BuzzFeed",
  "bvg": "BVG",
  "byjus": "Byju's",
  "bytedance": "ByteDance",
  "c": "C",
  "cachet": "Cachet",
  "cachyos": "CachyOS",
  "caddy": "Caddy",
  "cadillac": "Cadillac",
  "cafepress": "CafePress",
  "cairographics": "Cairo Graphics",
  "cairometro": "Cairo Metro",
  "caixabank": "CaixaBank",
  "cakephp": "CakePHP",
  "caldotcom": "Cal.com",
  "calendly": "Calendly",
  "calibreweb": "Calibre-Web",
  "campaignmonitor": "Campaign Monitor",
  "camunda": "Camunda",
  "canonical": "Canonical",
  "canvas": "Canvas",
  "capacitor": "Capacitor",
  "caprover": "CapRover",
  "cardano": "Cardano",
  "cardmarket": "Cardmarket",
  "carlsberggroup": "Carlsberg Group",
  "carrd": "Carrd",
  "carrefour": "Carrefour",
  "carthrottle": "Car Throttle",
  "carto": "Carto",
  "cashapp": "Cash App",
  "castbox": "Castbox",
  "castorama": "Castorama",
  "castro": "Castro",
  "caterpillar": "Caterpillar",
  "cbc": "CBC",
  "cbs": "CBS",
  "ccc": "CCC",
  "ccleaner": "CCleaner",
  "cdprojekt": "CD Projekt",
  "ce": "CE",
  "celery": "Celery",
  "celestron": "Celestron",
  "centos": "CentOS",
  "ceph": "Ceph",
  "cesium": "Cesium",
  "chai": "Chai",
  "chainguard": "Chainguard",
  "chainlink": "Chainlink",
  "chakraui": "Chakra UI",
  "changedetection": "Change Detection",
  "channel4": "Channel 4",
  "charles": "Charles",
  "chartdotjs": "Chart.js",
  "chartmogul": "ChartMogul",
  "chase": "Chase",
  "chatbot": "ChatBot",
  "chatwoot": "Chatwoot",
  "checkio": "CheckiO",
  "checkmarx": "Checkmarx",
  "checkmk": "Checkmk",
  "chedraui": "Chedraui",
  "cheerio": "Cheerio",
  "chef": "Chef",
  "chemex": "Chemex",
  "chessdotcom": "Chess.com",
  "chevrolet": "Chevrolet",
  "chianetwork": "Chia Network",
  "chinaeasternairlines": "China Eastern Airlines",
  "chinarailway": "China Railway",
  "chinasouthernairlines": "China Southern Airlines",
  "chocolatey": "Chocolatey",
  "chromatic": "Chromatic",
  "chromewebstore": "Chrome Web Store",
  "chrysler": "Chrysler",
  "chupachups": "Chupa Chups",
  "cilium": "Cilium",
  "cinema4d": "Cinema 4D",
  "cinnamon": "Cinnamon",
  "cinny": "Cinny",
  "circle": "Circle",
  "circleci": "CircleCI",
  "circuitverse": "CircuitVerse",
  "cirrusci": "Cirrus CI",
  "cisco": "Cisco",
  "citrix": "Citrix",
  "citroen": "Citro&#235;n",
  "civicrm": "CiviCRM",
  "civo": "Civo",
  "clarifai": "Clarifai",
  "claris": "Claris",
  "clarivate": "Clarivate",
  "claude": "Claude",
  "claudecode": "Claude Code",
  "clerk": "Clerk",
  "clevercloud": "Clever Cloud",
  "clickhouse": "ClickHouse",
  "clickup": "ClickUp",
  "cline": "Cline",
  "clion": "CLion",
  "clockify": "Clockify",
  "clojure": "Clojure",
  "cloud66": "Cloud 66",
  "cloudbees": "CloudBees",
  "cloudcannon": "CloudCannon",
  "cloudera": "Cloudera",
  "cloudflare": "Cloudflare",
  "cloudflarepages": "Cloudflare Pages",
  "cloudflareworkers": "Cloudflare Workers",
  "cloudfoundry": "Cloud Foundry",
  "cloudinary": "Cloudinary",
  "cloudnativebuild": "Cloud Native Build",
  "cloudron": "Cloudron",
  "cloudsmith": "Cloudsmith",
  "cloudways": "Cloudways",
  "clubforce": "Clubforce",
  "clubhouse": "Clubhouse",
  "clyp": "Clyp",
  "cmake": "CMake",
  "cncf": "CNCF",
  "cnes": "CNES",
  "cnet": "CNET",
  "cnn": "CNN",
  "cobalt": "cobalt",
  "cocacola": "Coca-Cola",
  "cockpit": "Cockpit",
  "cockroachlabs": "Cockroach Labs",
  "cocoapods": "CocoaPods",
  "cocos": "Cocos",
  "coda": "Coda",
  "codacy": "Codacy",
  "codeberg": "Codeberg",
  "codeblocks": "Code::Blocks",
  "codecademy": "Codecademy",
  "codeceptjs": "CodeceptJS",
  "codechef": "CodeChef",
  "codeclimate": "Code Climate",
  "codecov": "Codecov",
  "codecrafters": "CodeCrafters",
  "codefactor": "CodeFactor",
  "codeforces": "Codeforces",
  "codefresh": "Codefresh",
  "codeigniter": "CodeIgniter",
  "codemagic": "Codemagic",
  "codementor": "Codementor",
  "codemirror": "CodeMirror",
  "codenewbie": "CodeNewbie",
  "codeproject": "CodeProject",
  "coder": "Coder",
  "coderabbit": "CodeRabbit",
  "codersrank": "CodersRank",
  "coderwall": "Coderwall",
  "codesandbox": "CodeSandbox",
  "codeship": "Codeship",
  "codesignal": "CodeSignal",
  "codestream": "CodeStream",
  "codewars": "Codewars",
  "codingame": "CodinGame",
  "codingninjas": "Coding Ninjas",
  "codio": "Codio",
  "coffeescript": "CoffeeScript",
  "coggle": "Coggle",
  "coinbase": "Coinbase",
  "coinmarketcap": "CoinMarketCap",
  "collaboraonline": "Collabora Online",
  "comicfury": "ComicFury",
  "comma": "comma",
  "commerzbank": "Commerzbank",
  "commitlint": "commitlint",
  "commodore": "Commodore",
  "commonlisp": "Common Lisp",
  "commonworkflowlanguage": "Common Workflow Language",
  "compilerexplorer": "Compiler Explorer",
  "composer": "Composer",
  "comptia": "CompTIA",
  "comsol": "Comsol",
  "conan": "Conan",
  "concourse": "Concourse",
  "condaforge": "Conda-Forge",
  "conekta": "Conekta",
  "confluence": "Confluence",
  "construct3": "Construct 3",
  "consul": "Consul",
  "contabo": "Contabo",
  "contactlesspayment": "Contactless Payment",
  "containerd": "containerd",
  "contao": "Contao",
  "contensis": "Contensis",
  "contentful": "Contentful",
  "contentstack": "Contentstack",
  "continente": "Continente",
  "contributorcovenant": "Contributor Covenant",
  "conventionalcommits": "Conventional Commits",
  "convertio": "Convertio",
  "convex": "Convex",
  "cookiecutter": "Cookiecutter",
  "coolermaster": "Cooler Master",
  "coolify": "Coolify",
  "coop": "Co-op",
  "copaairlines": "Copa Airlines",
  "coppel": "Coppel",
  "cora": "Cora",
  "coreboot": "Coreboot",
  "coreldraw": "CorelDRAW",
  "coronaengine": "Corona Engine",
  "coronarenderer": "Corona Renderer",
  "corsair": "Corsair",
  "couchbase": "Couchbase",
  "counterstrike": "Counter-Strike",
  "countingworkspro": "CountingWorks PRO",
  "coursera": "Coursera",
  "coveralls": "Coveralls",
  "coze": "Coze",
  "cpanel": "cPanel",
  "cplusplus": "C++",
  "cplusplusbuilder": "C++ Builder",
  "craftcms": "Craft CMS",
  "craftsman": "Craftsman",
  "cratedb": "CrateDB",
  "crayon": "Crayon",
  "creality": "Creality",
  "createreactapp": "Create React App",
  "creativecommons": "Creative Commons",
  "creativetechnology": "Creative Technology",
  "credly": "Credly",
  "crehana": "Crehana",
  "crewai": "CrewAI",
  "crewunited": "Crew United",
  "criticalrole": "Critical Role",
  "crowdin": "Crowdin",
  "crowdsource": "Crowdsource",
  "crunchbase": "Crunchbase",
  "crunchyroll": "Crunchyroll",
  "cryengine": "CRYENGINE",
  "cryptomator": "Cryptomator",
  "cryptpad": "CryptPad",
  "crystal": "Crystal",
  "csdn": "CSDN",
  "css": "CSS",
  "cssdesignawards": "CSS Design Awards",
  "cssmodules": "CSS Modules",
  "csswizardry": "CSS Wizardry",
  "cts": "CTS",
  "cucumber": "Cucumber",
  "cultura": "Cultura",
  "curl": "curl",
  "curseforge": "CurseForge",
  "cursor": "Cursor",
  "customink": "Custom Ink",
  "cyberdefenders": "CyberDefenders",
  "cycling74": "Cycling '74",
  "cypress": "Cypress",
  "cytoscapedotjs": "Cytoscape.js",
  "d": "D",
  "d3": "D3",
  "dacia": "Dacia",
  "daf": "DAF",
  "dailydotdev": "daily.dev",
  "dailymotion": "Dailymotion",
  "daisyui": "daisyUI",
  "dapr": "Dapr",
  "darkreader": "Dark Reader",
  "dart": "Dart",
  "darty": "Darty",
  "daserste": "Das Erste",
  "dash": "Dash",
  "dash0": "Dash0",
  "dashlane": "Dashlane",
  "dask": "Dask",
  "dassaultsystemes": "Dassault Syst&#232;mes",
  "databricks": "Databricks",
  "datacamp": "DataCamp",
  "datadog": "Datadog",
  "datadotai": "data.ai",
  "datagrip": "DataGrip",
  "dataiku": "Dataiku",
  "datastax": "DataStax",
  "datefns": "date-fns",
  "datev": "DATEV",
  "datocms": "DatoCMS",
  "datto": "Datto",
  "davinciresolve": "DaVinci Resolve",
  "dazhongdianping": "Dazhong Dianping",
  "dazn": "DAZN",
  "dbeaver": "DBeaver",
  "dblp": "dblp",
  "dcentertainment": "DC Entertainment",
  "debian": "Debian",
  "debridlink": "Debrid-Link",
  "decapcms": "Decap CMS",
  "decentraland": "Decentraland",
  "dedge": "D-EDGE",
  "deepcool": "DeepCool",
  "deepgram": "Deepgram",
  "deepin": "deepin",
  "deepl": "DeepL",
  "deepmind": "DeepMind",
  "deepnote": "Deepnote",
  "deepseek": "DeepSeek",
  "deezer": "Deezer",
  "deliveroo": "Deliveroo",
  "dell": "Dell",
  "delonghi": "De'Longhi",
  "delphi": "Delphi",
  "delta": "Delta",
  "deluge": "Deluge",
  "deno": "Deno",
  "denodeploy": "Deno Deploy",
  "denon": "Denon",
  "dependabot": "Dependabot",
  "dependencycheck": "OWASP Dependency-Check",
  "depositphotos": "Depositphotos",
  "derspiegel": "Der Spiegel",
  "deutschebahn": "Deutsche Bahn",
  "deutschebank": "Deutsche Bank",
  "deutschepost": "Deutsche Post",
  "deutschetelekom": "Deutsche Telekom",
  "deutschewelle": "Deutsche Welle",
  "devbox": "Devbox",
  "devdotto": "dev.to",
  "developmentcontainers": "Development Containers",
  "devexpress": "DevExpress",
  "deviantart": "DeviantArt",
  "devpost": "Devpost",
  "devrant": "devRant",
  "devuan": "Devuan",
  "dgraph": "Dgraph",
  "dhl": "DHL",
  "diagramsdotnet": "diagrams.net",
  "dialogflow": "Dialogflow",
  "diaspora": "Diaspora",
  "dicebear": "DiceBear",
  "dictionarydotcom": "Dictionary.com",
  "dify": "Dify",
  "digg": "Digg",
  "digikeyelectronics": "Digi-Key Electronics",
  "digitalocean": "DigitalOcean",
  "dinersclub": "Diners Club",
  "dior": "Dior",
  "directus": "Directus",
  "discogs": "Discogs",
  "discord": "Discord",
  "discorddotjs": "discord.js",
  "discourse": "Discourse",
  "discover": "Discover",
  "disqus": "Disqus",
  "disroot": "Disroot",
  "distrobox": "Distrobox",
  "distrokid": "Distrokid",
  "django": "Django",
  "dji": "DJI",
  "dlib": "Dlib",
  "dlna": "DLNA",
  "dlthub": "dlthub",
  "dm": "dm",
  "dmm": "DMM",
  "docker": "Docker",
  "docsdotrs": "Docs.rs",
  "docsify": "Docsify",
  "doctrine": "Doctrine",
  "docusaurus": "Docusaurus",
  "dodopayments": "Dodo Payments",
  "dogecoin": "Dogecoin",
  "doi": "DOI",
  "dolby": "Dolby",
  "dolibarr": "Dolibarr",
  "dolphin": "Dolphin",
  "doordash": "DoorDash",
  "dota2": "Dota 2",
  "dotenv": ".ENV",
  "dotnet": ".NET",
  "douban": "Douban",
  "doubanread": "Douban Read",
  "dovecot": "Dovecot",
  "dovetail": "Dovetail",
  "downdetector": "Downdetector",
  "doxygen": "Doxygen",
  "dpd": "DPD",
  "dragonframe": "Dragonframe",
  "draugiemdotlv": "Draugiem.lv",
  "dreamstime": "Dreamstime",
  "dribbble": "Dribbble",
  "drizzle": "Drizzle",
  "drone": "Drone",
  "drooble": "Drooble",
  "dropbox": "Dropbox",
  "drupal": "Drupal",
  "dsautomobiles": "DS Automobiles",
  "dts": "DTS",
  "dtube": "DTube",
  "ducati": "Ducati",
  "duckdb": "DuckDB",
  "duckduckgo": "DuckDuckGo",
  "dungeonsanddragons": "Dungeons & Dragons",
  "dunked": "Dunked",
  "dunzo": "Dunzo",
  "duolingo": "Duolingo",
  "duplicati": "Duplicati",
  "dvc": "DVC",
  "dwavesystems": "D-Wave Systems",
  "dwm": "dwm",
  "dynatrace": "Dynatrace",
  "e": "/e/",
  "e3": "E3",
  "ea": "EA",
  "eac": "EAC",
  "eagle": "Eagle",
  "easyeda": "EasyEDA",
  "easyjet": "easyJet",
  "ebay": "eBay",
  "ebox": "EBOX",
  "eclipseadoptium": "Eclipse Adoptium",
  "eclipseche": "Eclipse Che",
  "eclipseide": "Eclipse IDE",
  "eclipsejetty": "Eclipse Jetty",
  "eclipsemosquitto": "Eclipse Mosquitto",
  "eclipsevertdotx": "Eclipse Vert.x",
  "ecosia": "Ecosia",
  "ecovacs": "Ecovacs",
  "edeka": "EDEKA",
  "edgeimpulse": "Edge Impulse",
  "editorconfig": "EditorConfig",
  "edotleclerc": "E.Leclerc",
  "educative": "Educative",
  "edx": "edX",
  "effect": "Effect",
  "egghead": "egghead",
  "egnyte": "Egnyte",
  "eight": "Eight",
  "eightsleep": "Eight Sleep",
  "ejs": "EJS",
  "elastic": "Elastic",
  "elasticcloud": "Elastic Cloud",
  "elasticsearch": "Elasticsearch",
  "elasticstack": "Elastic Stack",
  "elavon": "Elavon",
  "electron": "Electron",
  "electronbuilder": "electron-builder",
  "electronfiddle": "Electron Fiddle",
  "elegoo": "Elegoo",
  "element": "Element",
  "elementary": "elementary",
  "elementor": "Elementor",
  "elevenlabs": "ElevenLabs",
  "eleventy": "Eleventy",
  "elgato": "Elgato",
  "elixir": "Elixir",
  "elk": "Elk",
  "elm": "Elm",
  "elsevier": "Elsevier",
  "embarcadero": "Embarcadero",
  "embark": "Embark",
  "emberdotjs": "Ember.js",
  "emby": "Emby",
  "emirates": "Emirates",
  "emlakjet": "Emlakjet",
  "endeavouros": "EndeavourOS",
  "enpass": "Enpass",
  "ens": "ENS",
  "ente": "Ente",
  "enterprisedb": "EnterpriseDB",
  "envato": "Envato",
  "envoyproxy": "Envoy Proxy",
  "epel": "EPEL",
  "epicgames": "Epic Games",
  "epson": "Epson",
  "equinixmetal": "Equinix Metal",
  "eraser": "Eraser",
  "ericsson": "Ericsson",
  "erlang": "Erlang",
  "erpnext": "ERPNext",
  "esbuild": "esbuild",
  "esea": "ESEA",
  "eslgaming": "ESLGaming",
  "eslint": "ESLint",
  "esotericsoftware": "Esoteric Software",
  "esphome": "ESPHome",
  "espressif": "Espressif",
  "esri": "ESRI",
  "etcd": "etcd",
  "ethereum": "Ethereum",
  "ethers": "Ethers",
  "ethiopianairlines": "Ethiopian Airlines",
  "etihadairways": "Etihad Airways",
  "etsy": "Etsy",
  "europeanunion": "European Union",
  "eventstore": "Event Store",
  "evernote": "Evernote",
  "everydotorg": "Every.org",
  "excalidraw": "Excalidraw",
  "exercism": "Exercism",
  "exordo": "Exordo",
  "exoscale": "Exoscale",
  "expedia": "Expedia",
  "expensify": "Expensify",
  "expertsexchange": "Experts Exchange",
  "expo": "Expo",
  "express": "Express",
  "expressdotcom": "Express.com",
  "expressvpn": "ExpressVPN",
  "eyeem": "EyeEm",
  "f1": "F1",
  "f5": "F5",
  "facebook": "Facebook",
  "facebookgaming": "Facebook Gaming",
  "facebooklive": "Facebook Live",
  "faceit": "FACEIT",
  "facepunch": "Facepunch",
  "fairphone": "Fairphone",
  "faker": "Faker",
  "falco": "Falco",
  "falcon": "Falcon",
  "fampay": "FamPay",
  "fandango": "Fandango",
  "fandom": "Fandom",
  "fanfou": "Fanfou",
  "fantom": "Fantom",
  "farcaster": "Farcaster",
  "fareharbor": "FareHarbor",
  "farfetch": "FARFETCH",
  "fastapi": "FastAPI",
  "fastify": "Fastify",
  "fastlane": "Fastlane",
  "fastly": "Fastly",
  "fathom": "Fathom",
  "fauna": "Fauna",
  "favro": "Favro",
  "fcc": "FCC",
  "fdroid": "F-Droid",
  "fedex": "FedEx",
  "fedora": "Fedora",
  "feedly": "Feedly",
  "ferrari": "Ferrari",
  "ferrarinv": "Ferrari N.V.",
  "ferretdb": "FerretDB",
  "ffmpeg": "FFmpeg",
  "fi": "Fi",
  "fiat": "Fiat",
  "fidoalliance": "Fido Alliance",
  "fifa": "FIFA",
  "fig": "Fig",
  "figma": "Figma",
  "figshare": "figshare",
  "fila": "Fila",
  "filament": "Filament",
  "filedotio": "File.io",
  "filen": "Filen",
  "files": "Files",
  "filezilla": "FileZilla",
  "fillout": "Fillout",
  "fineco": "Fineco",
  "fing": "Fing",
  "firebase": "Firebase",
  "firefish": "Firefish",
  "fireflyiii": "Firefly III",
  "firefox": "Firefox",
  "firefoxbrowser": "Firefox Browser",
  "fireship": "Fireship",
  "firewalla": "Firewalla",
  "first": "FIRST",
  "fishaudio": "Fish Audio",
  "fishshell": "fish shell",
  "fitbit": "Fitbit",
  "fivem": "FiveM",
  "fiverr": "Fiverr",
  "fizz": "Fizz",
  "flashforge": "Flashforge",
  "flask": "Flask",
  "flat": "Flat",
  "flathub": "Flathub",
  "flatpak": "Flatpak",
  "flickr": "Flickr",
  "flightaware": "Flightaware",
  "flipboard": "Flipboard",
  "floatplane": "Floatplane",
  "flood": "Flood",
  "floorp": "Floorp",
  "flower": "Flower",
  "fluentbit": "Fluent Bit",
  "fluentd": "Fluentd",
  "fluke": "Fluke",
  "flutter": "Flutter",
  "flux": "Flux",
  "fluxer": "Fluxer",
  "flydotio": "Fly.io",
  "flyway": "Flyway",
  "fmod": "FMOD",
  "fnac": "Fnac",
  "folium": "Folium",
  "folo": "Folo",
  "fonoma": "Fonoma",
  "fontawesome": "Font Awesome",
  "fontbase": "FontBase",
  "fontforge": "FontForge",
  "foobar2000": "foobar2000",
  "foodpanda": "foodpanda",
  "ford": "Ford",
  "forgejo": "Forgejo",
  "formbricks": "Formbricks",
  "formik": "Formik",
  "formspree": "Formspree",
  "formstack": "Formstack",
  "fortinet": "Fortinet",
  "fortnite": "Fortnite",
  "fortran": "Fortran",
  "fossa": "Fossa",
  "fossilscm": "Fossil SCM",
  "foundryvirtualtabletop": "Foundry Virtual Tabletop",
  "foursquare": "Foursquare",
  "fox": "FOX",
  "foxtel": "Foxtel",
  "fozzy": "Fozzy",
  "framer": "Framer",
  "framework": "Framework",
  "framework7": "Framework7",
  "franprix": "Franprix",
  "frappe": "Frappe",
  "fraunhofergesellschaft": "Fraunhofer-Gesellschaft",
  "freebsd": "FreeBSD",
  "freecad": "FreeCAD",
  "freecodecamp": "freeCodeCamp",
  "freedesktopdotorg": "freedesktop.org",
  "freelancer": "Freelancer",
  "freelancermap": "freelancermap",
  "freenas": "FreeNAS",
  "freenet": "freenet",
  "freepik": "Freepik",
  "freetube": "FreeTube",
  "fresh": "Fresh",
  "freshrss": "FreshRSS",
  "frigate": "Frigate",
  "fritz": "FRITZ!",
  "frontendmentor": "Frontend Mentor",
  "frontify": "Frontify",
  "fsharp": "F#",
  "fubo": "Fubo",
  "fueler": "Fueler",
  "fugacloud": "Fuga Cloud",
  "fujifilm": "Fujifilm",
  "fujitsu": "Fujitsu",
  "furaffinity": "Fur Affinity",
  "furrynetwork": "Furry Network",
  "fusionauth": "FusionAuth",
  "futurelearn": "FutureLearn",
  "fyle": "Fyle",
  "g2": "G2",
  "g2a": "G2A",
  "g2g": "G2G",
  "galaxus": "Galaxus",
  "gamebanana": "GameBanana",
  "gamedeveloper": "Game Developer",
  "gamejolt": "Game Jolt",
  "gameloft": "Gameloft",
  "gamemaker": "Gamemaker",
  "gamescience": "Game Science",
  "gandi": "Gandi",
  "garmin": "Garmin",
  "garudalinux": "Garuda Linux",
  "gatling": "Gatling",
  "gatsby": "Gatsby",
  "gcore": "Gcore",
  "gdal": "GDAL",
  "geeksforgeeks": "GeeksforGeeks",
  "generalelectric": "General Electric",
  "generalmotors": "General Motors",
  "genius": "Genius",
  "gentoo": "Gentoo",
  "geocaching": "Geocaching",
  "geode": "Geode",
  "geopandas": "GeoPandas",
  "gerrit": "Gerrit",
  "getx": "GetX",
  "ghost": "Ghost",
  "ghostery": "Ghostery",
  "ghostfolio": "Ghostfolio",
  "ghostty": "Ghostty",
  "gimp": "GIMP",
  "gin": "Gin",
  "giphy": "GIPHY",
  "git": "Git",
  "gitbook": "GitBook",
  "gitcode": "GitCode",
  "gitconnected": "Gitconnected",
  "gitea": "Gitea",
  "gitee": "Gitee",
  "gitextensions": "Git Extensions",
  "gitforwindows": "Git for Windows",
  "github": "GitHub",
  "githubactions": "GitHub Actions",
  "githubcopilot": "GitHub Copilot",
  "githubpages": "GitHub Pages",
  "githubsponsors": "GitHub Sponsors",
  "gitignoredotio": "gitignore.io",
  "gitkraken": "GitKraken",
  "gitlab": "GitLab",
  "gitlfs": "Git LFS",
  "gitpod": "Gitpod",
  "gitter": "Gitter",
  "glance": "Glance",
  "glassdoor": "Glassdoor",
  "gldotinet": "GL.iNet",
  "gleam": "Gleam",
  "glide": "Glide",
  "glitch": "Glitch",
  "globus": "Globus",
  "glovo": "Glovo",
  "gltf": "glTF",
  "gmail": "Gmail",
  "gmx": "GMX",
  "gnome": "GNOME",
  "gnometerminal": "GNOME Terminal",
  "gnu": "GNU",
  "gnubash": "GNU Bash",
  "gnuemacs": "GNU Emacs",
  "gnuicecat": "GNU IceCat",
  "gnuprivacyguard": "GNU Privacy Guard",
  "gnusocial": "GNU social",
  "go": "Go",
  "gocd": "GoCD",
  "godaddy": "GoDaddy",
  "godotengine": "Godot Engine",
  "gofundme": "GoFundMe",
  "gogdotcom": "GOG.com",
  "gojek": "Gojek",
  "goland": "GoLand",
  "goldmansachs": "Goldman Sachs",
  "goodreads": "Goodreads",
  "google": "Google",
  "googleadmob": "Google AdMob",
  "googleads": "Google Ads",
  "googleadsense": "Google AdSense",
  "googleanalytics": "Google Analytics",
  "googleappsscript": "Google Apps Script",
  "googleassistant": "Google Assistant",
  "googleauthenticator": "Google Authenticator",
  "googlebigquery": "Google BigQuery",
  "googlebigtable": "Google Bigtable",
  "googlecalendar": "Google Calendar",
  "googlecampaignmanager360": "Google Campaign Manager 360",
  "googlecardboard": "Google Cardboard",
  "googlecast": "Google Cast",
  "googlechat": "Google Chat",
  "googlechrome": "Google Chrome",
  "googlechronicle": "Google Chronicle",
  "googleclassroom": "Google Classroom",
  "googlecloud": "Google Cloud",
  "googlecloudcomposer": "Google Cloud Composer",
  "googlecloudspanner": "Google Cloud Spanner",
  "googlecloudstorage": "Google Cloud Storage",
  "googlecolab": "Google Colab",
  "googlecontaineroptimizedos": "Google Container Optimized OS",
  "googledataflow": "Google Dataflow",
  "googledataproc": "Google Dataproc",
  "googledisplayandvideo360": "Google Display & Video 360",
  "googledocs": "Google Docs",
  "googledrive": "Google Drive",
  "googleearth": "Google Earth",
  "googleearthengine": "Google Earth Engine",
  "googlefonts": "Google Fonts",
  "googleforms": "Google Forms",
  "googlegemini": "Google Gemini",
  "googlehome": "Google Home",
  "googlejules": "Google Jules",
  "googlekeep": "Google Keep",
  "googlelens": "Google Lens",
  "googlemaps": "Google Maps",
  "googlemarketingplatform": "Google Marketing Platform",
  "googlemeet": "Google Meet",
  "googlemessages": "Google Messages",
  "googlenearby": "Google Nearby",
  "googlenews": "Google News",
  "googlepay": "Google Pay",
  "googlephotos": "Google Photos",
  "googleplay": "Google Play",
  "googlepubsub": "Google Pub/Sub",
  "googlescholar": "Google Scholar",
  "googlesearchconsole": "Google Search Console",
  "googlesheets": "Google Sheets",
  "googleslides": "Google Slides",
  "googlestreetview": "Google Street View",
  "googlesummerofcode": "Google Summer of Code",
  "googletagmanager": "Google Tag Manager",
  "googletasks": "Google Tasks",
  "googletranslate": "Google Translate",
  "googletv": "Google TV",
  "gotomeeting": "GoToMeeting",
  "gplv3": "GPLv3",
  "grab": "Grab",
  "gradio": "Gradio",
  "gradle": "Gradle",
  "gradleplaypublisher": "Gradle Play Publisher",
  "grafana": "Grafana",
  "grammarly": "Grammarly",
  "grandfrais": "Grand Frais",
  "grapheneos": "GrapheneOS",
  "graphite_editor": "Graphite",
  "graphite": "Graphite",
  "graphql": "GraphQL",
  "grav": "Grav",
  "gravatar": "Gravatar",
  "graylog": "Graylog",
  "greasyfork": "Greasy Fork",
  "greatlearning": "Great Learning",
  "greenhouse": "Greenhouse",
  "greensock": "GreenSock",
  "greptimedb": "GreptimeDB",
  "griddotai": "Grid.ai",
  "gridsome": "Gridsome",
  "grocy": "Grocy",
  "groupme": "GroupMe",
  "groupon": "Groupon",
  "grunt": "Grunt",
  "gsap": "GSAP",
  "gsk": "GSK",
  "gsma": "GSMA",
  "gsmarenadotcom": "GSMArena.com",
  "gstreamer": "GStreamer",
  "gtk": "GTK",
  "guangzhoumetro": "Guangzhou Metro",
  "guilded": "Guilded",
  "guitarpro": "Guitar Pro",
  "gulp": "gulp",
  "gumroad": "Gumroad",
  "gumtree": "Gumtree",
  "gunicorn": "Gunicorn",
  "gurobi": "Gurobi",
  "gusto": "Gusto",
  "gutenberg": "Gutenberg",
  "h2database": "H2 Database",
  "h3": "H3",
  "habr": "Habr",
  "hackaday": "Hackaday",
  "hackclub": "Hack Club",
  "hackerearth": "HackerEarth",
  "hackernoon": "Hacker Noon",
  "hackerone": "HackerOne",
  "hackerrank": "HackerRank",
  "hackmd": "HackMD",
  "hackster": "Hackster",
  "hackthebox": "Hack The Box",
  "hal": "HAL",
  "handlebarsdotjs": "Handlebars.js",
  "handm": "H&M",
  "handshake_protocol": "Handshake",
  "handshake": "Handshake",
  "happycow": "HappyCow",
  "harbor": "Harbor",
  "harmonyos": "HarmonyOS",
  "hashcat": "Hashcat",
  "hashicorp": "HashiCorp",
  "hashnode": "Hashnode",
  "haskell": "Haskell",
  "hasura": "Hasura",
  "hatenabookmark": "Hatena Bookmark",
  "haveibeenpwned": "Have I Been Pwned",
  "havells": "Havells",
  "haxe": "Haxe",
  "haystack": "Haystack",
  "hbo": "HBO",
  "hbomax": "HBO Max",
  "hcl": "HCL",
  "hdfcbank": "HDFC Bank",
  "headlessui": "Headless UI",
  "headphonezone": "Headphone Zone",
  "headspace": "Headspace",
  "hearth": "Hearth",
  "hearthisdotat": "hearthis.at",
  "hedera": "Hedera",
  "hedgedoc": "HedgeDoc",
  "helium": "Helium",
  "heliumbrowser": "Helium Browser",
  "helix": "Helix",
  "hellofresh": "HelloFresh",
  "hellyhansen": "Helly Hansen",
  "helm": "Helm",
  "helpdesk": "HelpDesk",
  "helpscout": "Help Scout",
  "hepsiemlak": "Hepsiemlak",
  "here": "HERE",
  "hermes": "Hermes",
  "heroicgameslauncher": "Heroic Games Launcher",
  "heroui": "HeroUI",
  "hetzner": "Hetzner",
  "hevy": "Hevy",
  "hexlet": "Hexlet",
  "hexo": "Hexo",
  "hey": "HEY",
  "hibernate": "Hibernate",
  "hibob": "Hi Bob",
  "hilton": "Hilton",
  "hiltonhotelsandresorts": "Hilton Hotels & Resorts",
  "hitachi": "Hitachi",
  "hive_blockchain": "Hive",
  "hive": "Hive",
  "hivemq": "HiveMQ",
  "homarr": "Homarr",
  "homeadvisor": "HomeAdvisor",
  "homeassistant": "Home Assistant",
  "homeassistantcommunitystore": "Home Assistant Community Store",
  "homebrew": "Homebrew",
  "homebridge": "Homebridge",
  "homepage": "Homepage",
  "homify": "homify",
  "honda": "Honda",
  "honey": "Honey",
  "honeybadger": "Honeybadger",
  "honeygain": "Honeygain",
  "hono": "Hono",
  "honor": "Honor",
  "hootsuite": "Hootsuite",
  "hoppscotch": "Hoppscotch",
  "hostinger": "Hostinger",
  "hotelsdotcom": "Hotels.com",
  "hotjar": "Hotjar",
  "hotwire": "Hotwire",
  "houdini": "Houdini",
  "houzz": "Houzz",
  "hp": "HP",
  "hsbc": "HSBC",
  "htc": "HTC",
  "htcvive": "HTC Vive",
  "html5": "HTML5",
  "htmlacademy": "HTML Academy",
  "htmx": "htmx",
  "htop": "htop",
  "httpie": "HTTPie",
  "huawei": "Huawei",
  "hubspot": "HubSpot",
  "huggingface": "Hugging Face",
  "hugo": "Hugo",
  "humblebundle": "Humble Bundle",
  "humhub": "HumHub",
  "hungryjacks": "Hungry Jack's",
  "husqvarna": "Husqvarna",
  "hyper": "Hyper",
  "hyperskill": "Hyperskill",
  "hyperx": "HyperX",
  "hypothesis": "Hypothesis",
  "hyprland": "Hyprland",
  "hyundai": "Hyundai",
  "i18next": "i18next",
  "i3": "i3",
  "iata": "IATA",
  "ibeacon": "iBeacon",
  "iberia": "Iberia",
  "iced": "Iced",
  "iceland": "Iceland",
  "icicibank": "ICICI Bank",
  "icinga": "Icinga",
  "icloud": "iCloud",
  "icomoon": "IcoMoon",
  "icon": "ICON",
  "iconfinder": "Iconfinder",
  "iconify": "Iconify",
  "iconjar": "IconJar",
  "icons8": "Icons8",
  "icq": "ICQ",
  "ieee": "IEEE",
  "ifixit": "iFixit",
  "ifood": "iFood",
  "ifttt": "IFTTT",
  "igdb": "IGDB",
  "ign": "IGN",
  "iheartradio": "iHeartRadio",
  "ikea": "IKEA",
  "iledefrancemobilites": "&#206;le-de-France Mobilit&#233;s",
  "ilovepdf": "iLovePDF",
  "imagedotsc": "Image.sc",
  "imagej": "ImageJ",
  "imagetoolbox": "Image Toolbox",
  "imdb": "IMDb",
  "imessage": "iMessage",
  "imgur": "Imgur",
  "immer": "Immer",
  "immersivetranslate": "Immersive Translate",
  "immich": "Immich",
  "imou": "Imou",
  "improvmx": "ImprovMX",
  "incall": "In call",
  "indeed": "Indeed",
  "indiansuperleague": "Indian Super League",
  "indiehackers": "Indie Hackers",
  "indieweb": "IndieWeb",
  "indigo": "IndiGo",
  "inductiveautomation": "Inductive Automation",
  "inertia": "Inertia",
  "infiniti": "INFINITI",
  "infinityfree": "InfinityFree",
  "influxdb": "InfluxDB",
  "infomaniak": "Infomaniak",
  "infoq": "InfoQ",
  "infosys": "Infosys",
  "infracost": "Infracost",
  "infuse": "Infuse",
  "ingress": "Ingress",
  "inkdrop": "Inkdrop",
  "inkscape": "Inkscape",
  "inoreader": "Inoreader",
  "inquirer": "Inquirer",
  "insomnia": "Insomnia",
  "inspire": "INSPIRE",
  "insta360": "Insta360",
  "instacart": "Instacart",
  "instagram": "Instagram",
  "instapaper": "Instapaper",
  "instatus": "Instatus",
  "instructables": "Instructables",
  "instructure": "Instructure",
  "intel": "Intel",
  "intellijidea": "IntelliJ IDEA",
  "interactiondesignfoundation": "Interaction Design Foundation",
  "interactjs": "InteractJS",
  "interbase": "Interbase",
  "intercom": "Intercom",
  "intermarche": "Intermarche",
  "internetarchive": "Internet Archive",
  "internetcomputer": "Internet Computer",
  "intigriti": "Intigriti",
  "intuit": "Intuit",
  "invidious": "Invidious",
  "invoiceninja": "Invoice Ninja",
  "iobroker": "ioBroker",
  "ionic": "Ionic",
  "ionos": "Ionos",
  "ios": "iOS",
  "iota": "IOTA",
  "ipfs": "IPFS",
  "iris": "IRIS",
  "irobot": "iRobot",
  "isc2": "ISC2",
  "isro": "ISRO",
  "issuu": "Issuu",
  "istio": "Istio",
  "itchdotio": "Itch.io",
  "iterm2": "iTerm2",
  "itunes": "iTunes",
  "itvx": "ITVx",
  "iveco": "IVECO",
  "jabber": "Jabber",
  "jaeger": "Jaeger",
  "jameson": "Jameson",
  "jamstack": "Jamstack",
  "japanairlines": "Japan Airlines",
  "jasmine": "Jasmine",
  "javascript": "JavaScript",
  "jbl": "JBL",
  "jcb": "JCB",
  "jdoodle": "JDoodle",
  "jeep": "Jeep",
  "jekyll": "Jekyll",
  "jellyfin": "Jellyfin",
  "jenkins": "Jenkins",
  "jest": "Jest",
  "jet": "JET",
  "jetblue": "JetBlue",
  "jetbrains": "JetBrains",
  "jetpackcompose": "Jetpack Compose",
  "jfrog": "JFrog",
  "jfrogpipelines": "JFrog Pipelines",
  "jhipster": "JHipster",
  "jinja": "Jinja",
  "jio": "Jio",
  "jira": "Jira",
  "jirasoftware": "Jira Software",
  "jitpack": "JitPack",
  "jitsi": "Jitsi",
  "johndeere": "John Deere",
  "joomla": "Joomla",
  "joplin": "Joplin",
  "jordan": "Jordan",
  "jouav": "JOUAV",
  "jovian": "Jovian",
  "jpeg": "JPEG",
  "jquery": "jQuery",
  "jrgroup": "JR Group",
  "jsdelivr": "jsDelivr",
  "jsfiddle": "JSFiddle",
  "json": "JSON",
  "jsonwebtokens": "JSON Web Tokens",
  "jsr": "JSR",
  "jss": "JSS",
  "juce": "JUCE",
  "juejin": "Juejin",
  "juke": "JUKE",
  "julia": "Julia",
  "junipernetworks": "Juniper Networks",
  "junit5": "JUnit5",
  "jupyter": "Jupyter",
  "just": "Just",
  "justeat": "Just Eat",
  "justgiving": "JustGiving",
  "k3s": "K3s",
  "k6": "k6",
  "kaggle": "Kaggle",
  "kagi": "Kagi",
  "kahoot": "Kahoot!",
  "kaios": "KaiOS",
  "kakao": "Kakao",
  "kakaotalk": "KakaoTalk",
  "kalilinux": "Kali Linux",
  "kamailio": "Kamailio",
  "kando": "Kando",
  "kaniko": "Kaniko",
  "karakeep": "Karakeep",
  "karlsruherverkehrsverbund": "Karlsruher Verkehrsverbund",
  "kasasmart": "Kasa Smart",
  "kashflow": "KashFlow",
  "kaspersky": "Kaspersky",
  "katana": "Katana",
  "kaufland": "Kaufland",
  "kde": "KDE",
  "kdeneon": "KDE neon",
  "kdenlive": "Kdenlive",
  "kdeplasma": "KDE Plasma",
  "kedro": "Kedro",
  "keenetic": "Keenetic",
  "keepachangelog": "Keep a Changelog",
  "keepassxc": "KeePassXC",
  "keeper": "Keeper",
  "keeweb": "KeeWeb",
  "kenmei": "Kenmei",
  "kentico": "Kentico",
  "keploy": "Keploy",
  "keras": "Keras",
  "keybase": "Keybase",
  "keycdn": "KeyCDN",
  "keycloak": "Keycloak",
  "keystone": "Keystone",
  "kfc": "KFC",
  "khanacademy": "Khan Academy",
  "khronosgroup": "Khronos Group",
  "kia": "Kia",
  "kibana": "Kibana",
  "kicad": "KiCad",
  "kick": "Kick",
  "kickstarter": "Kickstarter",
  "kik": "Kik",
  "kingstontechnology": "Kingston Technology",
  "kinopoisk": "Kinopoisk",
  "kinsta": "Kinsta",
  "kirby": "Kirby",
  "kit": "Kit",
  "kitsu": "Kitsu",
  "kiwix": "Kiwix",
  "klarna": "Klarna",
  "kleinanzeigen": "Kleinanzeigen",
  "klm": "KLM",
  "klook": "Klook",
  "knative": "Knative",
  "knexdotjs": "Knex.js",
  "knime": "KNIME",
  "knip": "Knip",
  "knowledgebase": "KnowledgeBase",
  "known": "Known",
  "koa": "Koa",
  "koc": "Koc",
  "kodak": "Kodak",
  "kodi": "Kodi",
  "kodular": "Kodular",
  "koenigsegg": "Koenigsegg",
  "kofax": "Kofax",
  "kofi": "Ko-fi",
  "komoot": "Komoot",
  "konami": "Konami",
  "kong": "Kong",
  "kongregate": "Kongregate",
  "konva": "Konva",
  "koreader": "KOReader",
  "kotlin": "Kotlin",
  "koyeb": "Koyeb",
  "kred": "Kred",
  "krita": "Krita",
  "ktm": "KTM",
  "ktor": "Ktor",
  "kuaishou": "Kuaishou",
  "kubernetes": "Kubernetes",
  "kubespray": "Kubespray",
  "kubuntu": "Kubuntu",
  "kucoin": "KuCoin",
  "kueski": "Kueski",
  "kuma": "Kuma",
  "kununu": "Kununu",
  "kuula": "Kuula",
  "kx": "KX",
  "kyocera": "Kyocera",
  "labex": "LabEx",
  "labview": "LabVIEW",
  "lada": "LADA",
  "lamborghini": "Lamborghini",
  "langchain": "LangChain",
  "langchaincorporate": "LangChain Corporate",
  "langflow": "Langflow",
  "langgraph": "LangGraph",
  "languagetool": "LanguageTool",
  "lapce": "Lapce",
  "laragon": "Laragon",
  "laravel": "Laravel",
  "laravelhorizon": "Laravel Horizon",
  "laravelnova": "Laravel Nova",
  "lastdotfm": "Last.fm",
  "lastpass": "LastPass",
  "latex": "LaTeX",
  "launchpad": "Launchpad",
  "lazarus": "Lazarus",
  "lazyvim": "LazyVim",
  "lbry": "LBRY",
  "leaderprice": "Leader Price",
  "leaflet": "Leaflet",
  "leagueoflegends": "League of Legends",
  "leanpub": "Leanpub",
  "leetcode": "LeetCode",
  "lefthook": "Lefthook",
  "legacygames": "Legacy Games",
  "leica": "Leica",
  "lemmy": "Lemmy",
  "lemonsqueezy": "Lemon Squeezy",
  "lenovo": "Lenovo",
  "lens": "Lens",
  "leptos": "Leptos",
  "lequipe": "L'&#201;quipe",
  "lerna": "Lerna",
  "leroymerlin": "Leroy Merlin",
  "leslibraires": "Les libraires",
  "less": "Less",
  "letsencrypt": "Let's Encrypt",
  "letterboxd": "Letterboxd",
  "levelsdotfyi": "levels.fyi",
  "lg": "LG",
  "liberadotchat": "Libera.Chat",
  "liberapay": "Liberapay",
  "librariesdotio": "Libraries.io",
  "librarything": "LibraryThing",
  "libreoffice": "LibreOffice",
  "libreofficebase": "LibreOffice Base",
  "libreofficecalc": "LibreOffice Calc",
  "libreofficedraw": "LibreOffice Draw",
  "libreofficeimpress": "LibreOffice Impress",
  "libreofficemath": "LibreOffice Math",
  "libreofficewriter": "LibreOffice Writer",
  "libretranslate": "LibreTranslate",
  "libretube": "LibreTube",
  "librewolf": "LibreWolf",
  "libuv": "libuv",
  "lichess": "Lichess",
  "lidl": "Lidl",
  "lifx": "LIFX",
  "lightburn": "LightBurn",
  "lighthouse": "Lighthouse",
  "lightning": "Lightning",
  "limesurvey": "LimeSurvey",
  "line": "LINE",
  "lineageos": "LineageOS",
  "linear": "Linear",
  "lining": "Li-Ning",
  "linkerd": "Linkerd",
  "linkfire": "Linkfire",
  "linksys": "Linksys",
  "linktree": "Linktree",
  "linkvertise": "Linkvertise",
  "linphone": "Linphone",
  "lintcode": "LintCode",
  "linux": "Linux",
  "linuxcontainers": "Linux Containers",
  "linuxfoundation": "Linux Foundation",
  "linuxmint": "Linux Mint",
  "linuxprofessionalinstitute": "Linux Professional Institute",
  "linuxserver": "LinuxServer",
  "lionair": "Lion Air",
  "liquibase": "Liquibase",
  "listenhub": "ListenHub",
  "listmonk": "listmonk",
  "lit": "Lit",
  "litecoin": "Litecoin",
  "literal": "Literal",
  "litiengine": "LITIENGINE",
  "livechat": "LiveChat",
  "livejournal": "LiveJournal",
  "livekit": "LiveKit",
  "livewire": "Livewire",
  "llvm": "LLVM",
  "lmms": "LMMS",
  "lmstudio": "LM Studio",
  "lobsters": "Lobsters",
  "local": "Local",
  "localsend": "LocalSend",
  "localxpose": "LocalXpose",
  "locust": "Locust",
  "lodash": "Lodash",
  "logmein": "LogMeIn",
  "logseq": "Logseq",
  "logstash": "Logstash",
  "longhorn": "Longhorn",
  "looker": "Looker",
  "loom": "Loom",
  "loop": "Loop",
  "loopback": "LoopBack",
  "loops": "Loops",
  "lootcrate": "Loot Crate",
  "lospec": "Lospec",
  "lotpolishairlines": "LOT Polish Airlines",
  "lottiefiles": "LottieFiles",
  "ltspice": "LTspice",
  "lua": "Lua",
  "luanti": "Luanti",
  "luau": "Luau",
  "lubuntu": "Lubuntu",
  "lucia": "Lucia",
  "lucid": "Lucid",
  "lucide": "Lucide",
  "ludwig": "Ludwig",
  "lufthansa": "Lufthansa",
  "lumen": "Lumen",
  "lunacy": "Lunacy",
  "luogu": "Luogu",
  "lutris": "Lutris",
  "lvgl": "LVGL",
  "lydia": "Lydia",
  "lyft": "Lyft",
  "m5stack": "M5Stack",
  "maas": "MAAS",
  "macos": "macOS",
  "macpaw": "MacPaw",
  "macports": "MacPorts",
  "macys": "Macy's",
  "magasinsu": "Magasins U",
  "magic": "Magic",
  "magisk": "Magisk",
  "mahindra": "Mahindra",
  "mailbox": "mailbox",
  "mailchimp": "MailChimp",
  "maildotcom": "mail.com",
  "maildotru": "Mail.Ru",
  "mailgun": "Mailgun",
  "mailtrap": "Mailtrap",
  "mainwp": "MainWP",
  "majorleaguehacking": "Major League Hacking",
  "make": "Make",
  "makerbot": "MakerBot",
  "malt": "Malt",
  "malwarebytes": "Malwarebytes",
  "mambaui": "Mamba UI",
  "mamp": "MAMP",
  "man": "MAN",
  "manageiq": "ManageIQ",
  "mangacollec": "Mangacollec",
  "mangaupdates": "MangaUpdates",
  "manjaro": "Manjaro",
  "mantine": "Mantine",
  "mapbox": "Mapbox",
  "mapillary": "Mapillary",
  "maplibre": "MapLibre",
  "maptiler": "MapTiler",
  "mariadb": "MariaDB",
  "mariadbfoundation": "MariaDB Foundation",
  "markdown": "Markdown",
  "marko": "Marko",
  "marriott": "Marriott",
  "marvelapp": "MarvelApp",
  "maserati": "Maserati",
  "mastercard": "MasterCard",
  "mastercomfig": "mastercomfig",
  "mastodon": "Mastodon",
  "materialdesign": "Material Design",
  "materialdesignicons": "Material Design Icons",
  "materialformkdocs": "Material for MkDocs",
  "matillion": "Matillion",
  "matomo": "Matomo",
  "matrix": "Matrix",
  "matterdotjs": "Matter.js",
  "mattermost": "Mattermost",
  "matternet": "Matternet",
  "mautic": "Mautic",
  "max": "Max",
  "maxplanckgesellschaft": "Max-Planck-Gesellschaft",
  "maytag": "Maytag",
  "mazda": "Mazda",
  "maze": "Maze",
  "mcafee": "McAfee",
  "mcdonalds": "McDonald's",
  "mclaren": "McLaren",
  "mdblist": "MDBList",
  "mdbook": "mdBook",
  "mdnwebdocs": "MDN Web Docs",
  "mdx": "MDX",
  "mealie": "Mealie",
  "mediafire": "MediaFire",
  "mediamarkt": "MediaMarkt",
  "mediapipe": "MediaPipe",
  "mediatek": "MediaTek",
  "medibangpaint": "MediBang Paint",
  "medium": "Medium",
  "medusa": "Medusa",
  "meetup": "Meetup",
  "mega": "MEGA",
  "meilisearch": "Meilisearch",
  "meituan": "Meituan",
  "meizu": "Meizu",
  "mendeley": "Mendeley",
  "mentorcruise": "MentorCruise",
  "mercadopago": "Mercado Pago",
  "merck": "Merck",
  "mercurial": "Mercurial",
  "mermaid": "Mermaid",
  "messenger": "Messenger",
  "meta": "Meta",
  "metabase": "Metabase",
  "metacritic": "Metacritic",
  "metafilter": "MetaFilter",
  "metager": "MetaGer",
  "metasploit": "Metasploit",
  "meteor": "Meteor",
  "metro": "Metro",
  "metrodelaciudaddemexico": "Metro de la Ciudad de M&#233;xico",
  "metrodemadrid": "Metro de Madrid",
  "metrodeparis": "M&#233;tro de Paris",
  "mewe": "MeWe",
  "mezmo": "Mezmo",
  "mg": "MG",
  "microbit": "micro:bit",
  "microdotblog": "Micro.blog",
  "microeditor": "Micro Editor",
  "micropython": "MicroPython",
  "microstation": "Microstation",
  "microstrategy": "MicroStrategy",
  "midi": "MIDI",
  "migadu": "Migadu",
  "mihon": "Mihon",
  "mihoyo": "miHoYo",
  "mikrotik": "MikroTik",
  "milanote": "Milanote",
  "milvus": "Milvus",
  "minds": "Minds",
  "mingww64": "MinGW-w64",
  "mini": "Mini",
  "minimax": "MiniMax",
  "minio": "MinIO",
  "mintlify": "Mintlify",
  "minutemailer": "Minutemailer",
  "miraheze": "Miraheze",
  "miro": "Miro",
  "misskey": "Misskey",
  "mistralai": "Mistral AI",
  "mitsubishi": "Mitsubishi",
  "mix": "Mix",
  "mixcloud": "Mixcloud",
  "mixpanel": "Mixpanel",
  "mlb": "MLB",
  "mlflow": "MLflow",
  "mobx": "MobX",
  "mobxstatetree": "MobX-State-Tree",
  "mocha": "Mocha",
  "mockserviceworker": "Mock Service Worker",
  "modal": "Modal",
  "modelcontextprotocol": "Model Context Protocol",
  "modelscope": "ModelScope",
  "modin": "Modin",
  "modrinth": "Modrinth",
  "modx": "MODX",
  "mojeek": "Mojeek",
  "moleculer": "Moleculer",
  "momenteo": "Momenteo",
  "monero": "Monero",
  "moneygram": "MoneyGram",
  "mongodb": "MongoDB",
  "mongoose": "Mongoose",
  "mongoosedotws": "Mongoose",
  "monica": "Monica",
  "monkeytie": "monkey tie",
  "monkeytype": "Monkeytype",
  "monogame": "MonoGame",
  "monoprix": "Monoprix",
  "monster": "Monster",
  "monzo": "Monzo",
  "moo": "Moo",
  "moodle": "Moodle",
  "moonrepo": "Moonrepo",
  "moonshotai": "Moonshot AI",
  "moq": "Moq",
  "moqups": "Moqups",
  "morrisons": "Morrisons",
  "moscowmetro": "Moscow Metro",
  "motorola": "Motorola",
  "movistar": "Movistar",
  "mozilla": "Mozilla",
  "mpv": "mpv",
  "mqtt": "MQTT",
  "msi": "MSI",
  "msibusiness": "MSI Business",
  "mta": "MTA",
  "mtr": "MTR",
  "mubi": "MUBI",
  "mui": "MUI",
  "muller": "M&#252;ller",
  "mullvad": "Mullvad",
  "multisim": "Multisim",
  "mumble": "Mumble",
  "muo": "MUO",
  "mural": "Mural",
  "musicbrainz": "MusicBrainz",
  "mxlinux": "MX Linux",
  "myanimelist": "MyAnimeList",
  "myget": "MyGet",
  "myob": "MYOB",
  "myshows": "MyShows",
  "myspace": "Myspace",
  "mysql": "MySQL",
  "n26": "N26",
  "n8n": "n8n",
  "namebase": "Namebase",
  "namecheap": "Namecheap",
  "namemc": "NameMC",
  "namesilo": "NameSilo",
  "namuwiki": "Namu Wiki",
  "nano": "Nano",
  "nanostores": "Nano Stores",
  "napster": "Napster",
  "nasa": "NASA",
  "nationalgrid": "National Grid",
  "nationalrail": "National Rail",
  "nativescript": "NativeScript",
  "natsdotio": "NATS.io",
  "naver": "Naver",
  "nba": "NBA",
  "nbb": "NBB",
  "nbc": "NBC",
  "ndi": "NDI",
  "ndr": "NDR",
  "near": "NEAR",
  "nebula": "Nebula",
  "nec": "NEC",
  "nederlandsespoorwegen": "Nederlandse Spoorwegen",
  "neo4j": "Neo4j",
  "neon": "Neon",
  "neovim": "Neovim",
  "neptune": "Neptune",
  "nestjs": "NestJS",
  "netapp": "NetApp",
  "netbsd": "NetBSD",
  "netcup": "netcup",
  "netdata": "Netdata",
  "neteasecloudmusic": "NetEase Cloud Music",
  "netflix": "Netflix",
  "netgear": "NETGEAR",
  "netim": "Netim",
  "netlify": "Netlify",
  "nette": "Nette",
  "netto": "Netto",
  "neutralinojs": "Neutralinojs",
  "newbalance": "New Balance",
  "newegg": "Newegg",
  "newgrounds": "Newgrounds",
  "newjapanprowrestling": "New Japan Pro-Wrestling",
  "newpipe": "NewPipe",
  "newrelic": "New Relic",
  "newyorktimes": "New York Times",
  "nexon": "NEXON",
  "nextbike": "nextbike",
  "nextbilliondotai": "NextBillion.ai",
  "nextcloud": "Nextcloud",
  "nextdns": "NextDNS",
  "nextdoor": "Nextdoor",
  "nextdotjs": "Next.js",
  "nextflow": "Nextflow",
  "nextra": "Nextra",
  "nfc": "NFC",
  "nfcore": "nf-core",
  "nginx": "NGINX",
  "nginxproxymanager": "Nginx Proxy Manager",
  "ngrok": "ngrok",
  "ngrx": "NgRx",
  "nhl": "NHL",
  "nhost": "Nhost",
  "nicehash": "NiceHash",
  "niconico": "niconico",
  "nike": "Nike",
  "nikon": "Nikon",
  "nim": "Nim",
  "niri": "niri",
  "nissan": "Nissan",
  "nixos": "NixOS",
  "nobaralinux": "Nobara Linux",
  "nodebb": "NodeBB",
  "nodedotjs": "Node.js",
  "nodegui": "NodeGui",
  "nodemon": "Nodemon",
  "nodered": "Node-RED",
  "nokia": "Nokia",
  "nomad": "Nomad",
  "norco": "Norco",
  "nordicsemiconductor": "Nordic Semiconductor",
  "nordvpn": "NordVPN",
  "normalizedotcss": "Normalize.css",
  "norton": "Norton",
  "norwegian": "Norwegian",
  "note": "Note",
  "notebooklm": "NotebookLM",
  "notepadplusplus": "Notepad++",
  "notion": "Notion",
  "notist": "Notist",
  "nounproject": "Noun Project",
  "novu": "Novu",
  "now": "NOW",
  "npm": "npm",
  "nrwl": "Nrwl",
  "nsis": "NSIS",
  "ntfy": "ntfy",
  "nubank": "Nubank",
  "nucleo": "Nucleo",
  "nuget": "NuGet",
  "nuke": "Nuke",
  "numba": "Numba",
  "numpy": "NumPy",
  "nunjucks": "Nunjucks",
  "nushell": "Nushell",
  "nutanix": "Nutanix",
  "nuxt": "Nuxt",
  "nvidia": "NVIDIA",
  "nvm": "nvm",
  "nx": "Nx",
  "nxp": "NXP",
  "nzxt": "NZXT",
  "o2": "O2",
  "obb": "&#214;BB",
  "observable": "Observable",
  "obsidian": "Obsidian",
  "obsstudio": "OBS Studio",
  "obtainium": "Obtainium",
  "ocaml": "OCaml",
  "oclc": "OCLC",
  "oclif": "oclif",
  "octanerender": "Octane Render",
  "octave": "Octave",
  "octobercms": "October CMS",
  "octoprint": "OctoPrint",
  "octopusdeploy": "Octopus Deploy",
  "oculus": "Oculus",
  "odido": "Odido",
  "odin": "Odin",
  "odnoklassniki": "Odnoklassniki",
  "odoo": "Odoo",
  "odysee": "Odysee",
  "ohdear": "Oh Dear",
  "okcupid": "okcupid",
  "okta": "Okta",
  "okx": "OKX",
  "ollama": "Ollama",
  "omadacloud": "Omada Cloud",
  "omarchy": "Omarchy",
  "oneplus": "OnePlus",
  "onestream": "OneStream",
  "onlyfans": "OnlyFans",
  "onlyoffice": "ONLYOFFICE",
  "onnx": "ONNX",
  "onstar": "OnStar",
  "opel": "Opel",
  "open3d": "Open3D",
  "openaccess": "Open Access",
  "openai": "OpenAI",
  "openaigym": "OpenAI Gym",
  "openapiinitiative": "OpenAPI Initiative",
  "openbadges": "Open Badges",
  "openbao": "OpenBao",
  "openbsd": "OpenBSD",
  "openbugbounty": "Open Bug Bounty",
  "opencage": "OpenCage",
  "opencode": "OpenCode",
  "opencollective": "Open Collective",
  "opencontainersinitiative": "Open Containers Initiative",
  "opencritic": "OpenCritic",
  "opencv": "OpenCV",
  "openfaas": "OpenFaaS",
  "opengl": "OpenGL",
  "openhab": "openHAB",
  "openid": "OpenID",
  "openjdk": "OpenJDK",
  "openjsfoundation": "OpenJS Foundation",
  "openlayers": "Openlayers",
  "openmediavault": "openmediavault",
  "openmined": "OpenMined",
  "opennebula": "OpenNebula",
  "openproject": "OpenProject",
  "openrouter": "OpenRouter",
  "openscad": "OpenSCAD",
  "opensea": "OpenSea",
  "opensearch": "OpenSearch",
  "opensourcehardware": "Open Source Hardware",
  "opensourceinitiative": "Open Source Initiative",
  "openssl": "OpenSSL",
  "openstack": "OpenStack",
  "openstreetmap": "OpenStreetMap",
  "opensuse": "openSUSE",
  "opentelemetry": "OpenTelemetry",
  "opentext": "OpenText",
  "opentofu": "OpenTofu",
  "opentui": "OpenTUI",
  "openverse": "Openverse",
  "openvpn": "OpenVPN",
  "openwrt": "OpenWrt",
  "openzeppelin": "OpenZeppelin",
  "openzfs": "OpenZFS",
  "opera": "Opera",
  "operagx": "Opera GX",
  "opnsense": "OPNsense",
  "oppo": "OPPO",
  "opsgenie": "Opsgenie",
  "opslevel": "OpsLevel",
  "optimism": "Optimism",
  "optuna": "Optuna",
  "orange": "Orange",
  "orchardcore": "Orchard Core",
  "orcid": "ORCID",
  "oreilly": "O'Reilly",
  "org": "Org",
  "organicmaps": "Organic Maps",
  "origin": "Origin",
  "ory": "Ory",
  "osano": "Osano",
  "osf": "OSF",
  "osgeo": "OSGeo",
  "oshkosh": "Oshkosh",
  "osmand": "OsmAnd",
  "osmc": "OSMC",
  "osu": "osu!",
  "otto": "Otto",
  "outline": "Outline",
  "overcast": "Overcast",
  "overleaf": "Overleaf",
  "ovh": "OVH",
  "owasp": "OWASP",
  "owncloud": "ownCloud",
  "oxc": "Oxc",
  "oxygen": "Oxygen",
  "oyo": "OYO",
  "p5dotjs": "p5.js",
  "packagist": "Packagist",
  "packer": "Packer",
  "packt": "Packt",
  "paddle": "Paddle",
  "paddlepaddle": "PaddlePaddle",
  "paddypower": "Paddy Power",
  "padlet": "Padlet",
  "pagekit": "Pagekit",
  "pagerduty": "PagerDuty",
  "pagespeedinsights": "PageSpeed Insights",
  "pagseguro": "PagSeguro",
  "palantir": "Palantir",
  "paloaltonetworks": "Palo Alto Networks",
  "paloaltosoftware": "Palo Alto Software",
  "panasonic": "Panasonic",
  "pandas": "pandas",
  "pandoc": "Pandoc",
  "pandora": "Pandora",
  "pangolin": "Pangolin",
  "pantheon": "Pantheon",
  "paperlessngx": "Paperless-ngx",
  "paperspace": "Paperspace",
  "paperswithcode": "Papers With Code",
  "paradoxinteractive": "Paradox Interactive",
  "paramountplus": "Paramount+",
  "paritysubstrate": "Parity Substrate",
  "parrotsecurity": "Parrot Security",
  "parsedotly": "Parse.ly",
  "passbolt": "Passbolt",
  "passport": "Passport",
  "pastebin": "Pastebin",
  "patreon": "Patreon",
  "payback": "PAYBACK",
  "paychex": "Paychex",
  "payhip": "Payhip",
  "payloadcms": "Payload CMS",
  "payoneer": "Payoneer",
  "paypal": "PayPal",
  "paysafe": "Paysafe",
  "paytm": "Paytm",
  "pcgamingwiki": "PCGamingWiki",
  "pdm": "PDM",
  "pdq": "PDQ",
  "peakdesign": "Peak Design",
  "pearson": "Pearson",
  "peerlist": "Peerlist",
  "peertube": "PeerTube",
  "pegasusairlines": "Pegasus Airlines",
  "pelican": "Pelican",
  "peloton": "Peloton",
  "penny": "Penny",
  "penpot": "Penpot",
  "percy": "Percy",
  "perforce": "Perforce",
  "perl": "Perl",
  "perplexity": "Perplexity",
  "persistent": "Persistent",
  "personio": "Personio",
  "petsathome": "Pets at Home",
  "peugeot": "Peugeot",
  "pexels": "Pexels",
  "pfsense": "pfSense",
  "phabricator": "Phabricator",
  "philipshue": "Philips Hue",
  "phoenixframework": "Phoenix Framework",
  "phonepe": "PhonePe",
  "phosphoricons": "Phosphor Icons",
  "photobucket": "Photobucket",
  "photocrowd": "Photocrowd",
  "photon": "Photon",
  "photopea": "Photopea",
  "php": "PHP",
  "phpbb": "phpBB",
  "phpmyadmin": "phpMyAdmin",
  "phpstorm": "PhpStorm",
  "pi": "Pi",
  "piaggiogroup": "Piaggio Group",
  "piapro": "Piapro",
  "picardsurgeles": "Picard Surgel&#233;s",
  "picartodottv": "Picarto.TV",
  "picnic": "Picnic",
  "picpay": "PicPay",
  "picrew": "Picrew",
  "picsart": "Picsart",
  "picxy": "Picxy",
  "pihole": "Pi-hole",
  "pimcore": "Pimcore",
  "pinboard": "Pinboard",
  "pinescript": "Pine Script",
  "pinetwork": "Pi Network",
  "pingdom": "Pingdom",
  "pinia": "Pinia",
  "pino": "pino",
  "pinterest": "Pinterest",
  "pioneerdj": "Pioneer DJ",
  "pipecat": "Pipecat",
  "piped": "Piped",
  "pipx": "pipx",
  "pivotaltracker": "Pivotal Tracker",
  "piwigo": "Piwigo",
  "pix": "Pix",
  "pixabay": "Pixabay",
  "pixelfed": "Pixelfed",
  "pixiv": "pixiv",
  "pixlr": "Pixlr",
  "pkgsrc": "pkgsrc",
  "plane": "Plane",
  "planet": "Planet",
  "planetscale": "PlanetScale",
  "plangrid": "PlanGrid",
  "platformdotsh": "Platform.sh",
  "platformio": "PlatformIO",
  "platzi": "Platzi",
  "plausibleanalytics": "Plausible Analytics",
  "playcanvas": "PlayCanvas",
  "playerdotme": "Player.me",
  "playerfm": "Player FM",
  "playstation": "PlayStation",
  "playstation2": "PlayStation 2",
  "playstation3": "PlayStation 3",
  "playstation4": "PlayStation 4",
  "playstation5": "PlayStation 5",
  "playstationportable": "PlayStation Portable",
  "playstationvita": "PlayStation Vita",
  "pleroma": "Pleroma",
  "plesk": "Plesk",
  "plex": "Plex",
  "plotly": "Plotly",
  "plume": "Plume",
  "pluralsight": "Pluralsight",
  "plurk": "Plurk",
  "pm2": "PM2",
  "pnpm": "pnpm",
  "pocketbase": "PocketBase",
  "pocketcasts": "Pocket Casts",
  "podcastaddict": "Podcast Addict",
  "podcastindex": "Podcast Index",
  "podman": "Podman",
  "poe": "Poe",
  "poetry": "Poetry",
  "polars": "Polars",
  "polestar": "Polestar",
  "polkadot": "Polkadot",
  "poly": "Poly",
  "polygon": "Polygon",
  "polymerproject": "Polymer Project",
  "polywork": "Polywork",
  "pomerium": "Pomerium",
  "pond5": "Pond5",
  "popos": "Pop!_OS",
  "porkbun": "Porkbun",
  "porsche": "Porsche",
  "portableappsdotcom": "PortableApps.com",
  "portainer": "Portainer",
  "portswigger": "PortSwigger",
  "posit": "Posit",
  "postcss": "PostCSS",
  "postgresql": "PostgreSQL",
  "posthog": "PostHog",
  "postiz": "Postiz",
  "postman": "Postman",
  "postmates": "Postmates",
  "powers": "POWERS",
  "prdotco": "pr.co",
  "preact": "Preact",
  "precommit": "pre-commit",
  "prefect": "Prefect",
  "prek": "prek",
  "premid": "PreMiD",
  "premierleague": "Premier League",
  "prepbytes": "PrepBytes",
  "prestashop": "PrestaShop",
  "presto": "Presto",
  "prettier": "Prettier",
  "pretzel": "Pretzel",
  "prevention": "Prevention",
  "prezi": "Prezi",
  "primefaces": "PrimeFaces",
  "primeng": "PrimeNG",
  "primereact": "PrimeReact",
  "primevue": "PrimeVue",
  "printables": "Printables",
  "prisma": "Prisma",
  "prismic": "Prismic",
  "privatedivision": "Private Division",
  "privateinternetaccess": "Private Internet Access",
  "probot": "Probot",
  "processingfoundation": "Processing Foundation",
  "processon": "ProcessOn",
  "processwire": "ProcessWire",
  "producthunt": "Product Hunt",
  "progate": "Progate",
  "progress": "Progress",
  "prometheus": "Prometheus",
  "pronounsdotpage": "Pronouns.page",
  "prosemirror": "ProseMirror",
  "prosieben": "ProSieben",
  "proteus": "Proteus",
  "protocolsdotio": "protocols.io",
  "protodotio": "Proto.io",
  "proton": "Proton",
  "protoncalendar": "Proton Calendar",
  "protondb": "ProtonDB",
  "protondrive": "Proton Drive",
  "protonmail": "Proton Mail",
  "protonvpn": "Proton VPN",
  "protools": "Pro Tools",
  "protractor": "Protractor",
  "proxmox": "Proxmox",
  "pterodactyl": "Pterodactyl",
  "pubg": "PUBG",
  "publons": "Publons",
  "pubmed": "PubMed",
  "pug": "Pug",
  "pulumi": "Pulumi",
  "puma": "Puma",
  "puppet": "Puppet",
  "puppeteer": "Puppeteer",
  "purescript": "PureScript",
  "purgecss": "PurgeCSS",
  "purism": "Purism",
  "pushbullet": "Pushbullet",
  "pusher": "Pusher",
  "pwa": "PWA",
  "pycharm": "PyCharm",
  "pycqa": "PyCQA",
  "pydantic": "Pydantic",
  "pyg": "PyG",
  "pypi": "PyPI",
  "pypy": "PyPy",
  "pyscaffold": "PyScaffold",
  "pysyft": "PySyft",
  "pytest": "Pytest",
  "python": "Python",
  "pythonanywhere": "PythonAnywhere",
  "pytorch": "PyTorch",
  "pyup": "PyUp",
  "qantas": "Qantas",
  "qase": "Qase",
  "qatarairways": "Qatar Airways",
  "qbittorrent": "qbittorrent",
  "qdrant": "Qdrant",
  "qemu": "QEMU",
  "qgis": "QGIS",
  "qi": "Qi",
  "qiita": "Qiita",
  "qiskit": "Qiskit",
  "qiwi": "QIWI",
  "qlik": "Qlik",
  "qlty": "Qlty",
  "qmk": "QMK",
  "qnap": "QNAP",
  "qodo": "Qodo",
  "qq": "QQ",
  "qt": "Qt",
  "quad9": "Quad9",
  "qualcomm": "Qualcomm",
  "qualtrics": "Qualtrics",
  "qualys": "Qualys",
  "quantcast": "Quantcast",
  "quantconnect": "QuantConnect",
  "quarkus": "Quarkus",
  "quarto": "Quarto",
  "quasar": "Quasar",
  "qubesos": "Qubes OS",
  "quest": "Quest",
  "quickbooks": "QuickBooks",
  "quicklook": "QuickLook",
  "quicktime": "QuickTime",
  "quicktype": "quicktype",
  "quizlet": "Quizlet",
  "quora": "Quora",
  "qwant": "Qwant",
  "qwen": "QWen",
  "qwik": "Qwik",
  "qwiklabs": "Qwiklabs",
  "qzone": "Qzone",
  "r": "R",
  "r3": "R3",
  "rabbitmq": "RabbitMQ",
  "racket": "Racket",
  "radar": "Radar",
  "radarr": "radarr",
  "radiofrance": "Radio France",
  "radixui": "Radix UI",
  "radstudio": "RAD Studio",
  "railway": "Railway",
  "rainmeter": "Rainmeter",
  "rainyun": "RainYun",
  "rakuten": "Rakuten",
  "rakutenkobo": "Rakuten Kobo",
  "ram": "Ram",
  "rancher": "Rancher",
  "rapid": "Rapid",
  "rarible": "Rarible",
  "rasa": "Rasa",
  "raspberrypi": "Raspberry Pi",
  "ratatui": "Ratatui",
  "ravelry": "Ravelry",
  "ray": "Ray",
  "raycast": "Raycast",
  "raylib": "Raylib",
  "razer": "Razer",
  "razorpay": "Razorpay",
  "rclone": "Rclone",
  "react": "React",
  "reactbootstrap": "React Bootstrap",
  "reacthookform": "React Hook Form",
  "reactiveresume": "Reactive Resume",
  "reactivex": "ReactiveX",
  "reactos": "ReactOS",
  "reactquery": "React Query",
  "reactrouter": "React Router",
  "reacttable": "React Table",
  "readdotcv": "Read.cv",
  "readme": "ReadMe",
  "readthedocs": "Read the Docs",
  "reason": "Reason",
  "reasonstudios": "Reason Studios",
  "recoil": "Recoil",
  "red": "Red",
  "redash": "Redash",
  "redbubble": "Redbubble",
  "redbull": "Red Bull",
  "redcandlegames": "Red Candle Games",
  "reddit": "Reddit",
  "redhat": "Red Hat",
  "redhatopenshift": "Red Hat Open Shift",
  "redis": "Redis",
  "redmine": "Redmine",
  "redox": "Redox",
  "redragon": "Redragon",
  "redsys": "Redsys",
  "redux": "Redux",
  "reduxsaga": "Redux-Saga",
  "redwoodjs": "RedwoodJS",
  "reebok": "Reebok",
  "refine": "Refine",
  "refinedgithub": "Refined GitHub",
  "reflex": "Reflex",
  "rekaui": "Reka UI",
  "relay": "Relay",
  "relianceindustrieslimited": "Reliance Industries Limited",
  "remark": "remark",
  "remedyentertainment": "Remedy Entertainment",
  "remix": "Remix",
  "removedotbg": "remove.bg",
  "renault": "Renault",
  "render": "Render",
  "renovate": "Renovate",
  "renpy": "Ren'Py",
  "renren": "Renren",
  "replicate": "Replicate",
  "replit": "Replit",
  "republicofgamers": "Republic of Gamers",
  "rescript": "ReScript",
  "rescuetime": "RescueTime",
  "researchgate": "ResearchGate",
  "resend": "Resend",
  "resharper": "ReSharper",
  "resurrectionremixos": "Resurrection Remix OS",
  "retool": "Retool",
  "retroachievements": "Retro Achievements",
  "retroarch": "RetroArch",
  "retropie": "RetroPie",
  "revanced": "ReVanced",
  "revealdotjs": "reveal.js",
  "revenuecat": "RevenueCat",
  "reverbnation": "ReverbNation",
  "revoltdotchat": "Revolt.chat",
  "revolut": "Revolut",
  "rewe": "REWE",
  "rezgo": "Rezgo",
  "rhinoceros": "Rhinoceros",
  "rich": "Rich",
  "rider": "Rider",
  "rimacautomobili": "Rimac Automobili",
  "rime": "Rime",
  "ring": "Ring",
  "riotgames": "Riot Games",
  "ripple": "Ripple",
  "riscv": "RISC-V",
  "riseup": "Riseup",
  "ritzcarlton": "Ritz Carlton",
  "rive": "Rive",
  "roadmapdotsh": "roadmap.sh",
  "roamresearch": "Roam Research",
  "robinhood": "Robinhood",
  "roblox": "Roblox",
  "robloxstudio": "Roblox Studio",
  "roboflow": "Roboflow",
  "robotframework": "Robot Framework",
  "rocket": "Rocket",
  "rocketdotchat": "Rocket.Chat",
  "rocksdb": "RocksDB",
  "rockstargames": "Rockstar Games",
  "rockwellautomation": "Rockwell Automation",
  "rockylinux": "Rocky Linux",
  "roku": "Roku",
  "roll20": "Roll20",
  "rollbar": "Rollbar",
  "rolldown": "Rolldown",
  "rollsroyce": "Rolls-Royce",
  "rollupdotjs": "rollup.js",
  "rook": "Rook",
  "roon": "Roon",
  "root": "ROOT",
  "rootme": "Root Me",
  "roots": "Roots",
  "rootsbedrock": "Roots Bedrock",
  "rootssage": "Roots Sage",
  "ros": "ROS",
  "rossmann": "Rossmann",
  "rotaryinternational": "Rotary International",
  "rottentomatoes": "Rotten Tomatoes",
  "roundcube": "Roundcube",
  "rsocket": "RSocket",
  "rss": "RSS",
  "rstudioide": "RStudio IDE",
  "rte": "RT&#201;",
  "rtl": "RTL",
  "rtlzwei": "RTLZWEI",
  "rtm": "RTM",
  "rubocop": "RuboCop",
  "ruby": "Ruby",
  "rubygems": "RubyGems",
  "rubymine": "RubyMine",
  "rubyonrails": "Ruby on Rails",
  "rubysinatra": "Ruby Sinatra",
  "ruff": "Ruff",
  "rumahweb": "Rumahweb",
  "rumble": "Rumble",
  "rundeck": "Rundeck",
  "runkeeper": "Runkeeper",
  "runkit": "RunKit",
  "runrundotit": "Runrun.it",
  "rust": "Rust",
  "rustdesk": "RustDesk",
  "rustfs": "RustFS",
  "rxdb": "RxDB",
  "ryanair": "Ryanair",
  "rye": "Rye",
  "s7airlines": "S7 Airlines",
  "sabanci": "Sabanci",
  "safari": "Safari",
  "sage": "Sage",
  "sagemath": "SageMath",
  "sahibinden": "Sahibinden",
  "sailfishos": "Sailfish OS",
  "sailsdotjs": "Sails.js",
  "salla": "Salla",
  "saltproject": "Salt Project",
  "samsclub": "Sam's Club",
  "samsung": "Samsung",
  "samsungpay": "Samsung Pay",
  "sanfranciscomunicipalrailway": "San Francisco Municipal Railway",
  "sanic": "Sanic",
  "sanity": "Sanity",
  "saopaulometro": "S&#227;o Paulo Metro",
  "sap": "SAP",
  "sartorius": "Sartorius",
  "sass": "Sass",
  "sat1": "Sat.1",
  "satellite": "Satellite",
  "saturn": "Saturn",
  "saucelabs": "Sauce Labs",
  "saudia": "Saudia",
  "scala": "Scala",
  "scalar": "Scalar",
  "scaleway": "Scaleway",
  "scan": "Scan",
  "scania": "Scania",
  "schneiderelectric": "Schneider Electric",
  "scikitlearn": "scikit-learn",
  "scilab": "Scilab",
  "scipy": "SciPy",
  "scopus": "Scopus",
  "scpfoundation": "SCP Foundation",
  "scrapbox": "Scrapbox",
  "scrapy": "Scrapy",
  "scratch": "Scratch",
  "screen0": "Screen0",
  "screencastify": "Screencastify",
  "screenshotui": "Screenshot UI",
  "scrimba": "Scrimba",
  "scrollreveal": "ScrollReveal",
  "scrumalliance": "Scrum Alliance",
  "scrutinizerci": "Scrutinizer CI",
  "scylladb": "ScyllaDB",
  "seafile": "Seafile",
  "seagate": "Seagate",
  "searxng": "SearXNG",
  "seat": "SEAT",
  "seatgeek": "SeatGeek",
  "securityscorecard": "SecurityScorecard",
  "sefaria": "Sefaria",
  "sega": "Sega",
  "selenium": "Selenium",
  "sellfy": "Sellfy",
  "semanticrelease": "semantic-release",
  "semanticscholar": "Semantic Scholar",
  "semanticui": "Semantic UI",
  "semanticuireact": "Semantic UI React",
  "semanticweb": "Semantic Web",
  "semaphoreci": "Semaphore CI",
  "semrush": "Semrush",
  "semver": "SemVer",
  "sencha": "Sencha",
  "sennheiser": "Sennheiser",
  "sensu": "Sensu",
  "sentry": "Sentry",
  "sepa": "SEPA",
  "sequelize": "Sequelize",
  "servbay": "ServBay",
  "serverfault": "Server Fault",
  "serverless": "Serverless",
  "session": "Session",
  "sessionize": "Sessionize",
  "setapp": "Setapp",
  "settings": "Settings",
  "setuptools": "Setuptools",
  "sfml": "SFML",
  "shadcnui": "shadcn/ui",
  "shadow": "Shadow",
  "shanghaimetro": "Shanghai Metro",
  "sharex": "ShareX",
  "sharp": "sharp",
  "shazam": "Shazam",
  "shell": "Shell",
  "shelly": "Shelly",
  "shenzhenmetro": "Shenzhen Metro",
  "shieldsdotio": "Shields.io",
  "shikimori": "Shikimori",
  "shopee": "Shopee",
  "shopify": "Shopify",
  "shopware": "Shopware",
  "shortcut": "Shortcut",
  "showpad": "Showpad",
  "showtime": "Showtime",
  "showwcase": "Showwcase",
  "sidekiq": "Sidekiq",
  "sidequest": "SideQuest",
  "siemens": "Siemens",
  "sifive": "SiFive",
  "signal": "Signal",
  "silverairways": "Silver Airways",
  "similarweb": "Similarweb",
  "simkl": "Simkl",
  "simpleanalytics": "Simple Analytics",
  "simpleicons": "Simple Icons",
  "simplelocalize": "SimpleLocalize",
  "simplelogin": "SimpleLogin",
  "simplenote": "Simplenote",
  "simplex": "SimpleX",
  "sinaweibo": "Sina Weibo",
  "singaporeairlines": "Singapore Airlines",
  "singlestore": "SingleStore",
  "sitecore": "Sitecore",
  "sitepoint": "SitePoint",
  "siyuan": "SiYuan",
  "skaffold": "Skaffold",
  "skeleton": "Skeleton",
  "sketch": "Sketch",
  "sketchfab": "Sketchfab",
  "sketchup": "SketchUp",
  "skillshare": "Skillshare",
  "skoda": "&#352;KODA",
  "sky": "Sky",
  "skypack": "Skypack",
  "slackware": "Slackware",
  "slashdot": "Slashdot",
  "slickpic": "SlickPic",
  "slides": "Slides",
  "slideshare": "SlideShare",
  "slint": "Slint",
  "smart": "smart",
  "smartthings": "SmartThings",
  "smashingmagazine": "Smashing Magazine",
  "smoothcomp": "Smoothcomp",
  "smrt": "SMRT",
  "smugmug": "SmugMug",
  "snapchat": "Snapchat",
  "snapcraft": "Snapcraft",
  "snapdragon": "Snapdragon",
  "sncf": "SNCF",
  "snort": "Snort",
  "snowflake": "Snowflake",
  "snowpack": "Snowpack",
  "snyk": "Snyk",
  "socialblade": "Social Blade",
  "society6": "Society6",
  "socket": "Socket",
  "socketdotio": "Socket.io",
  "softcatala": "Softcatal&#224;",
  "softpedia": "Softpedia",
  "sogou": "Sogou",
  "solana": "Solana",
  "solid": "Solid",
  "solidity": "Solidity",
  "sololearn": "Sololearn",
  "solus": "Solus",
  "solveddotac": "solved.ac",
  "sonar": "Sonar",
  "sonarqubecloud": "SonarQube Cloud",
  "sonarqubeforide": "SonarQube for IDE",
  "sonarqubeserver": "SonarQube Server",
  "sonarr": "sonarr",
  "sonatype": "Sonatype",
  "songkick": "Songkick",
  "songoda": "Songoda",
  "sonicwall": "SonicWall",
  "sonos": "Sonos",
  "sony": "Sony",
  "soriana": "Soriana",
  "soundcharts": "Soundcharts",
  "soundcloud": "SoundCloud",
  "sourceengine": "Source Engine",
  "sourceforge": "SourceForge",
  "sourcehut": "SourceHut",
  "sourcetree": "Sourcetree",
  "southwestairlines": "Southwest Airlines",
  "spacemacs": "Spacemacs",
  "spaceship": "Spaceship",
  "spacex": "SpaceX",
  "spacy": "spaCy",
  "sparkar": "Spark AR",
  "sparkasse": "Sparkasse",
  "sparkfun": "SparkFun",
  "sparkpost": "SparkPost",
  "spdx": "SPDX",
  "speakerdeck": "Speaker Deck",
  "spectrum": "Spectrum",
  "speedtest": "Speedtest",
  "speedypage": "SpeedyPage",
  "sphinx": "Sphinx",
  "spidermonkey": "SpiderMonkey",
  "spigotmc": "SpigotMC",
  "spine": "Spine",
  "spinnaker": "Spinnaker",
  "splunk": "Splunk",
  "spoj": "Sphere Online Judge",
  "spond": "Spond",
  "spotify": "Spotify",
  "spotlight": "Spotlight",
  "spreadshirt": "Spreadshirt",
  "spreaker": "Spreaker",
  "spring_creators": "Spring",
  "spring": "Spring",
  "springboot": "Spring Boot",
  "springsecurity": "Spring Security",
  "spyderide": "Spyder IDE",
  "sqlalchemy": "SQLAlchemy",
  "sqlite": "SQLite",
  "square": "Square",
  "squareenix": "Square Enix",
  "squarespace": "Squarespace",
  "srgssr": "SRG SSR",
  "ssrn": "SSRN",
  "sst": "SST",
  "stackbit": "Stackbit",
  "stackblitz": "StackBlitz",
  "stackedit": "StackEdit",
  "stackexchange": "Stack Exchange",
  "stackhawk": "StackHawk",
  "stackoverflow": "Stack Overflow",
  "stackshare": "StackShare",
  "stadia": "Stadia",
  "staffbase": "Staffbase",
  "stagetimer": "Stagetimer",
  "standardjs": "StandardJS",
  "standardresume": "Standard Resume",
  "starbucks": "Starbucks",
  "stardock": "Stardock",
  "starlingbank": "Starling Bank",
  "starship": "Starship",
  "startdotgg": "start.gg",
  "startpage": "Startpage",
  "startrek": "Star Trek",
  "starz": "STARZ",
  "statamic": "Statamic",
  "statista": "Statista",
  "statuspage": "Statuspage",
  "statuspal": "Statuspal",
  "steam": "Steam",
  "steamdb": "SteamDB",
  "steamdeck": "Steam Deck",
  "steamworks": "Steamworks",
  "steelseries": "Steelseries",
  "steem": "Steem",
  "steemit": "Steemit",
  "steinberg": "Steinberg",
  "stellar": "Stellar",
  "stencil": "Stencil",
  "stencyl": "Stencyl",
  "stimulus": "Stimulus",
  "stmicroelectronics": "STMicroelectronics",
  "stockx": "StockX",
  "stopstalk": "StopStalk",
  "storyblok": "Storyblok",
  "storybook": "Storybook",
  "strapi": "Strapi",
  "strava": "Strava",
  "streamlabs": "Streamlabs",
  "streamlit": "Streamlit",
  "streamrunners": "StreamRunners",
  "stremio": "Stremio",
  "stripe": "Stripe",
  "strongswan": "strongSwan",
  "stryker": "Stryker",
  "stubhub": "StubHub",
  "studio3t": "Studio 3T",
  "styledcomponents": "styled-components",
  "stylelint": "stylelint",
  "styleshare": "StyleShare",
  "stylus": "Stylus",
  "subaru": "Subaru",
  "sublimetext": "Sublime Text",
  "substack": "Substack",
  "subtitleedit": "Subtitle Edit",
  "subversion": "Subversion",
  "suckless": "suckless",
  "sui": "Sui",
  "suitest": "Suitest",
  "sumologic": "Sumo Logic",
  "suno": "Suno",
  "sunrise": "Sunrise",
  "supabase": "Supabase",
  "supercell": "Supercell",
  "supercrease": "Supercrease",
  "supermicro": "Supermicro",
  "superuser": "Super User",
  "surfshark": "Surfshark",
  "surrealdb": "SurrealDB",
  "surveymonkey": "SurveyMonkey",
  "suse": "SUSE",
  "suzuki": "Suzuki",
  "svelte": "Svelte",
  "svg": "SVG",
  "svgdotjs": "SVG.js",
  "svgo": "SVGO",
  "svgtrace": "SvgTrace",
  "swagger": "Swagger",
  "swarm": "Swarm",
  "sway": "Sway",
  "swc": "SWC",
  "swift": "Swift",
  "swiggy": "Swiggy",
  "swiper": "Swiper",
  "swisscows": "Swisscows",
  "swr": "SWR",
  "symantec": "Symantec",
  "symbolab": "Symbolab",
  "symfony": "Symfony",
  "symphony": "Symphony",
  "sympy": "SymPy",
  "syncthing": "Syncthing",
  "synology": "Synology",
  "system76": "System76",
  "tabelog": "Tabelog",
  "tablecheck": "TableCheck",
  "tacobell": "Taco Bell",
  "tado": "tado&#176;",
  "taichigraphics": "Taichi Graphics",
  "taichilang": "Taichi Lang",
  "tails": "Tails",
  "tailscale": "Tailscale",
  "tailwindcss": "Tailwind CSS",
  "taipy": "Taipy",
  "taketwointeractivesoftware": "Take-Two Interactive Software",
  "talend": "Talend",
  "talenthouse": "Talenthouse",
  "talos": "Talos",
  "tamiya": "Tamiya",
  "tampermonkey": "Tampermonkey",
  "tanstack": "TanStack",
  "taobao": "Taobao",
  "tapas": "Tapas",
  "target": "Target",
  "tarom": "TAROM",
  "tarteaucitron": "Tarteaucitron",
  "task": "Task",
  "tasmota": "Tasmota",
  "tata": "Tata",
  "tauri": "Tauri",
  "taxbuzz": "TaxBuzz",
  "tcs": "Tata Consultancy Services",
  "teal": "Teal",
  "teamcity": "TeamCity",
  "teamspeak": "TeamSpeak",
  "teamviewer": "TeamViewer",
  "techcrunch": "TechCrunch",
  "ted": "TED",
  "teepublic": "TeePublic",
  "teespring": "Teespring",
  "tekton": "Tekton",
  "tele5": "TELE 5",
  "telefonica": "Telef&#243;nica",
  "telegram": "Telegram",
  "telegraph": "Telegraph",
  "telenor": "Telenor",
  "telequebec": "T&#233;l&#233;-Qu&#233;bec",
  "temporal": "Temporal",
  "tensorflow": "TensorFlow",
  "teradata": "Teradata",
  "teratail": "teratail",
  "termius": "Termius",
  "terraform": "Terraform",
  "tesco": "Tesco",
  "tesla": "Tesla",
  "testcafe": "TestCafe",
  "testin": "Testin",
  "testinglibrary": "Testing Library",
  "testrail": "TestRail",
  "tether": "Tether",
  "textpattern": "Textpattern",
  "textual": "Textual",
  "tga": "TGA",
  "thangs": "Thangs",
  "thanos": "Thanos",
  "thealgorithms": "The Algorithms",
  "theboringcompany": "The Boring Company",
  "theconversation": "The Conversation",
  "thefinals": "THE FINALS",
  "theguardian": "The Guardian",
  "theirishtimes": "The Irish Times",
  "themighty": "The Mighty",
  "themodelsresource": "The Models Resource",
  "themoviedatabase": "The Movie Database",
  "thenorthface": "The North Face",
  "theodinproject": "The Odin Project",
  "theplanetarysociety": "The Planetary Society",
  "theregister": "The Register",
  "thesoundsresource": "The Sounds Resource",
  "thespritersresource": "The Spriters Resource",
  "thestorygraph": "The StoryGraph",
  "thewashingtonpost": "The Washington Post",
  "theweatherchannel": "The Weather Channel",
  "thingiverse": "Thingiverse",
  "things": "Things",
  "thinkpad": "ThinkPad",
  "thirdweb": "thirdweb",
  "threadless": "Threadless",
  "threads": "Threads",
  "threedotjs": "Three.js",
  "threema": "Threema",
  "thumbtack": "Thumbtack",
  "thunderbird": "Thunderbird",
  "thunderstore": "Thunderstore",
  "thurgauerkantonalbank": "Thurgauer Kantonalbank",
  "thymeleaf": "Thymeleaf",
  "ticketmaster": "Ticketmaster",
  "tickettailor": "Ticket Tailor",
  "ticktick": "TickTick",
  "tidal": "TIDAL",
  "tidb": "TiDB",
  "tiddlywiki": "TiddlyWiki",
  "tide": "Tide",
  "tidyverse": "Tidyverse",
  "tietoevry": "TietoEVRY",
  "tiktok": "TikTok",
  "tildapublishing": "Tilda Publishing",
  "tile": "Tile",
  "timescale": "Timescale",
  "tina": "Tina",
  "tinder": "Tinder",
  "tindie": "Tindie",
  "tinkercad": "Tinkercad",
  "tinygrad": "tinygrad",
  "tinyletter": "TinyLetter",
  "tistory": "Tistory",
  "tldraw": "tldraw",
  "tmux": "tmux",
  "todoist": "Todoist",
  "toggl": "Toggl",
  "toggltrack": "Toggl Track",
  "tokio": "Tokio",
  "tokyometro": "Tokyo Metro",
  "toll": "Toll",
  "toml": "TOML",
  "tomorrowland": "Tomorrowland",
  "tomtom": "TomTom",
  "ton": "TON",
  "topcoder": "Topcoder",
  "topdotgg": "Top.gg",
  "toptal": "Toptal",
  "torbrowser": "Tor Browser",
  "torizon": "Torizon",
  "torproject": "Tor Project",
  "toshiba": "Toshiba",
  "totvs": "TOTVS",
  "tourbox": "TourBox",
  "tower": "Tower",
  "toyota": "Toyota",
  "tplink": "TP-Link",
  "tqdm": "tqdm",
  "traccar": "Traccar",
  "tradingview": "TradingView",
  "traefikmesh": "Traefik Mesh",
  "traefikproxy": "Traefik Proxy",
  "trailforks": "Trailforks",
  "trainerroad": "TrainerRoad",
  "trakt": "Trakt",
  "transifex": "Transifex",
  "transmission": "Transmission",
  "transportforireland": "Transport for Ireland",
  "transportforlondon": "Transport for London",
  "travisci": "Travis CI",
  "treehouse": "Treehouse",
  "trello": "Trello",
  "trendmicro": "Trend Micro",
  "tresorit": "Tresorit",
  "treyarch": "Treyarch",
  "trezor": "Trezor",
  "tricentis": "Tricentis",
  "trilium": "Trilium",
  "triller": "Triller",
  "trillertv": "TrillerTV",
  "trimble": "Trimble",
  "trino": "Trino",
  "tripadvisor": "Tripadvisor",
  "tripdotcom": "Trip.com",
  "trivago": "trivago",
  "trivy": "Trivy",
  "trmnl": "TRMNL",
  "trove": "Trove",
  "trpc": "tRPC",
  "truenas": "TrueNAS",
  "trueup": "TrueUp",
  "trulia": "trulia",
  "trustedshops": "Trusted Shops",
  "trustpilot": "Trustpilot",
  "tryhackme": "TryHackMe",
  "tryitonline": "Try It Online",
  "tsnode": "ts-node",
  "tubi": "Tubi",
  "tui": "TUI",
  "tumblr": "Tumblr",
  "turbo": "Turbo",
  "turborepo": "Turborepo",
  "turbosquid": "TurboSquid",
  "turkishairlines": "Turkish Airlines",
  "turso": "Turso",
  "tuta": "Tuta",
  "tuxedocomputers": "TUXEDO Computers",
  "tv4play": "TV4 Play",
  "tvtime": "TV Time",
  "twenty": "Twenty",
  "twinkly": "Twinkly",
  "twinmotion": "Twinmotion",
  "twitch": "Twitch",
  "ty": "ty",
  "typeform": "Typeform",
  "typeorm": "TypeORM",
  "typer": "Typer",
  "typescript": "TypeScript",
  "typo3": "TYPO3",
  "typst": "Typst",
  "uber": "Uber",
  "ubereats": "Uber Eats",
  "ubiquiti": "Ubiquiti",
  "ubisoft": "Ubisoft",
  "ublockorigin": "uBlock Origin",
  "ubuntu": "Ubuntu",
  "ubuntumate": "Ubuntu MATE",
  "udacity": "Udacity",
  "udemy": "Udemy",
  "udotsdotnews": "U.S. News",
  "ufc": "UFC",
  "uikit": "UIkit",
  "uipath": "UiPath",
  "ukca": "UKCA",
  "ultralytics": "Ultralytics",
  "ulule": "Ulule",
  "umami": "Umami",
  "umbraco": "Umbraco",
  "umbrel": "Umbrel",
  "uml": "UML",
  "unacademy": "Unacademy",
  "underarmour": "Under Armour",
  "underscoredotjs": "Underscore.js",
  "undertale": "Undertale",
  "unicode": "Unicode",
  "unilever": "Unilever",
  "uniqlo_ja": "Uniqlo",
  "uniqlo": "Uniqlo",
  "unitedairlines": "United Airlines",
  "unitednations": "United Nations",
  "unity": "Unity",
  "unjs": "UnJS",
  "unlicense": "Unlicense",
  "unocss": "UnoCSS",
  "unpkg": "unpkg",
  "unraid": "Unraid",
  "unrealengine": "Unreal Engine",
  "unsplash": "Unsplash",
  "unstop": "Unstop",
  "untappd": "Untappd",
  "upcloud": "UpCloud",
  "uphold": "Uphold",
  "uplabs": "UpLabs",
  "upptime": "Upptime",
  "ups": "UPS",
  "upstash": "Upstash",
  "uptimekuma": "Uptime Kuma",
  "upwork": "Upwork",
  "uservoice": "UserVoice",
  "usps": "USPS",
  "utorrent": "uTorrent",
  "uv": "uv",
  "v": "V",
  "v0": "v0",
  "v2ex": "V2EX",
  "v8": "V8",
  "vaadin": "Vaadin",
  "vagrant": "Vagrant",
  "vala": "Vala",
  "valorant": "Valorant",
  "valve": "Valve",
  "vanillaextract": "Vanilla Extract",
  "vapor": "Vapor",
  "vault": "Vault",
  "vaultwarden": "Vaultwarden",
  "vauxhall": "Vauxhall",
  "vbulletin": "vBulletin",
  "vectary": "Vectary",
  "vectorlogozone": "Vector Logo Zone",
  "vectorworks": "Vectorworks",
  "veeam": "Veeam",
  "veed": "VEED",
  "veepee": "Veepee",
  "vega": "Vega",
  "vegas": "VEGAS",
  "velocity": "Velocity",
  "velog": "Velog",
  "vencord": "Vencord",
  "venmo": "Venmo",
  "vercel": "Vercel",
  "verdaccio": "Verdaccio",
  "veritas": "Veritas",
  "verizon": "Verizon",
  "vespa": "Vespa",
  "vestel": "Vestel",
  "vexxhost": "VEXXHOST",
  "vfairs": "vFairs",
  "viadeo": "Viadeo",
  "viaplay": "Viaplay",
  "viber": "Viber",
  "viblo": "Viblo",
  "victoriametrics": "VictoriaMetrics",
  "victronenergy": "Victron Energy",
  "vikunja": "Vikunja",
  "vim": "Vim",
  "vimeo": "Vimeo",
  "vimeolivestream": "Vimeo Livestream",
  "vinted": "Vinted",
  "virgin": "Virgin",
  "virginatlantic": "Virgin Atlantic",
  "virginmedia": "Virgin Media",
  "virtualbox": "VirtualBox",
  "virustotal": "VirusTotal",
  "visa": "Visa",
  "visualparadigm": "Visual Paradigm",
  "visx": "visx",
  "vite": "Vite",
  "vitepress": "VitePress",
  "vitess": "Vitess",
  "vitest": "Vitest",
  "vivaldi": "Vivaldi",
  "vivawallet": "Viva Wallet",
  "vivino": "Vivino",
  "vivint": "Vivint",
  "vivo": "vivo",
  "vk": "VK",
  "vlcmediaplayer": "VLC media player",
  "vllm": "vLLM",
  "vmware": "VMware",
  "vodafone": "Vodafone",
  "voelkner": "voelkner",
  "voidlinux": "Void Linux",
  "voipdotms": "VoIP.ms",
  "volkswagen": "Volkswagen",
  "volvo": "Volvo",
  "vonage": "Vonage",
  "vorondesign": "Voron Design",
  "vowpalwabbit": "Vowpal Wabbit",
  "vox": "VOX",
  "vrchat": "VRChat",
  "vsco": "VSCO",
  "vscodium": "VSCodium",
  "vtex": "VTEX",
  "vuedotjs": "Vue.js",
  "vuetify": "Vuetify",
  "vueuse": "VueUse",
  "vulkan": "Vulkan",
  "vultr": "Vultr",
  "vyond": "Vyond",
  "w3schools": "W3Schools",
  "wacom": "Wacom",
  "wagmi": "Wagmi",
  "wagtail": "Wagtail",
  "wails": "Wails",
  "wakatime": "WakaTime",
  "walkman": "WALKMAN",
  "wallabag": "Wallabag",
  "walletconnect": "WalletConnect",
  "wantedly": "Wantedly",
  "wappalyzer": "Wappalyzer",
  "warp": "Warp",
  "wasabi": "Wasabi",
  "wasmcloud": "wasmCloud",
  "wasmer": "Wasmer",
  "watchtower": "Watchtower",
  "wattpad": "Wattpad",
  "wayland": "Wayland",
  "waze": "Waze",
  "wazirx": "WazirX",
  "wearos": "Wear OS",
  "weasyl": "Weasyl",
  "web3dotjs": "Web3.js",
  "webassembly": "WebAssembly",
  "webauthn": "WebAuthn",
  "webawesome": "Web Awesome",
  "webcomponentsdotorg": "webcomponents.org",
  "webdotde": "WEB.DE",
  "webdriverio": "WebdriverIO",
  "webex": "Webex",
  "webflow": "Webflow",
  "webgl": "WebGL",
  "webgpu": "WebGPU",
  "weblate": "Weblate",
  "webmin": "Webmin",
  "webmoney": "WebMoney",
  "webpack": "Webpack",
  "webrtc": "WebRTC",
  "webstorm": "WebStorm",
  "webtoon": "WEBTOON",
  "webtrees": "webtrees",
  "wechat": "WeChat",
  "wegame": "WeGame",
  "weightsandbiases": "Weights & Biases",
  "welcometothejungle": "Welcome to the Jungle",
  "wellfound": "Wellfound",
  "wellsfargo": "Wells Fargo",
  "wemo": "WEMO",
  "weread": "WeRead",
  "westernunion": "Western Union",
  "wetransfer": "WeTransfer",
  "wezterm": "WezTerm",
  "wgpu": "wgpu",
  "what3words": "what3words",
  "whatsapp": "WhatsApp",
  "wheniwork": "When I Work",
  "wikibooks": "Wikibooks",
  "wikidata": "Wikidata",
  "wikidotgg": "wiki.gg",
  "wikidotjs": "Wiki.js",
  "wikimediacommons": "Wikimedia Commons",
  "wikimediafoundation": "Wikimedia Foundation",
  "wikipedia": "Wikipedia",
  "wikiquote": "Wikiquote",
  "wikisource": "Wikisource",
  "wikiversity": "Wikiversity",
  "wikivoyage": "Wikivoyage",
  "winamp": "Winamp",
  "windsurf": "Windsurf",
  "wine": "Wine",
  "wipro": "Wipro",
  "wire": "Wire",
  "wireguard": "WireGuard",
  "wireshark": "Wireshark",
  "wise": "Wise",
  "wish": "Wish",
  "wistia": "Wistia",
  "wix": "Wix",
  "wizzair": "Wizz Air",
  "wolfram": "Wolfram",
  "wolframlanguage": "Wolfram Language",
  "wolframmathematica": "Wolfram Mathematica",
  "wondershare": "Wondershare",
  "wondersharefilmora": "Wondershare Filmora",
  "woo": "Woo",
  "woocommerce": "WooCommerce",
  "wordpress": "WordPress",
  "workplace": "Workplace",
  "worldhealthorganization": "World Health Organization",
  "wpengine": "WP Engine",
  "wpexplorer": "WPExplorer",
  "wprocket": "WP Rocket",
  "writedotas": "Write.as",
  "wwe": "WWE",
  "wwise": "Wwise",
  "wxt": "WXT",
  "wykop": "Wykop",
  "wyze": "Wyze",
  "x": "X",
  "xampp": "XAMPP",
  "xcode": "Xcode",
  "xdadevelopers": "XDA Developers",
  "xdotorg": "X.Org",
  "xendit": "Xendit",
  "xero": "Xero",
  "xfce": "XFCE",
  "xiaohongshu": "Xiaohongshu",
  "xiaomi": "Xiaomi",
  "xing": "Xing",
  "xml": "XML",
  "xmpp": "XMPP",
  "xo": "XO",
  "xrp": "XRP",
  "xsplit": "XSplit",
  "xstate": "XState",
  "xubuntu": "Xubuntu",
  "xyflow": "xyflow",
  "yaak": "Yaak",
  "yabai": "yabai",
  "yale": "Yale",
  "yamahacorporation": "Yamaha Corporation",
  "yamahamotorcorporation": "Yamaha Motor Corporation",
  "yaml": "YAML",
  "yandexcloud": "Yandex Cloud",
  "yarn": "Yarn",
  "ycombinator": "Y Combinator",
  "yelp": "Yelp",
  "yeti": "Yeti",
  "yew": "Yew",
  "yii": "Yii",
  "yoast": "Yoast",
  "yolo": "YOLO",
  "youhodler": "YouHodler",
  "youtube": "YouTube",
  "youtubegaming": "YouTube Gaming",
  "youtubekids": "YouTube Kids",
  "youtubemusic": "YouTube Music",
  "youtubeshorts": "YouTube Shorts",
  "youtubestudio": "YouTube Studio",
  "youtubetv": "YouTube TV",
  "yr": "Yr",
  "yubico": "Yubico",
  "yunohost": "YunoHost",
  "zabka": "&#379;abka",
  "zaim": "Zaim",
  "zalando": "Zalando",
  "zalo": "Zalo",
  "zap": "ZAP",
  "zapier": "Zapier",
  "zara": "Zara",
  "zazzle": "Zazzle",
  "zcash": "Zcash",
  "zcool": "ZCOOL",
  "zdf": "ZDF",
  "zebpay": "ZebPay",
  "zebratechnologies": "Zebra Technologies",
  "zedindustries": "Zed Industries",
  "zelle": "Zelle",
  "zenbrowser": "Zen Browser",
  "zend": "Zend",
  "zendesk": "Zendesk",
  "zenn": "Zenn",
  "zenodo": "Zenodo",
  "zensar": "Zensar",
  "zerodha": "Zerodha",
  "zerotier": "ZeroTier",
  "zettlr": "Zettlr",
  "zhihu": "Zhihu",
  "zig": "Zig",
  "zigbee": "Zigbee",
  "zigbee2mqtt": "Zigbee2MQTT",
  "ziggo": "Ziggo",
  "zilch": "Zilch",
  "zillow": "Zillow",
  "zincsearch": "ZincSearch",
  "zingat": "Zingat",
  "zod": "Zod",
  "zoho": "Zoho",
  "zoiper": "Zoiper",
  "zola": "Zola",
  "zomato": "Zomato",
  "zoom": "Zoom",
  "zorin": "Zorin",
  "zotero": "Zotero",
  "zsh": "Zsh",
  "zulip": "Zulip",
  "zyte": "Zyte",
};
